/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect, useRef } from "react";
import classnames from "classnames";
import NumberFormat from "react-number-format";
import Skeleton from "react-loading-skeleton";
import axiosInstance from "./../../helpers/axiosInstance";
import MyModal from "components/Modal/Modal";
import santander from '../../assets/img/brand/santander.png';
import exitoCreacion from '../../assets/img/illustrations/add-contact-success.svg';
import ComponentemodificaUsu from './modificaUsuario.js'

import IconTid from '../../assets/img/icons/Icono-Tipo-de-documento-Gris.png'


import icon_Administras_usuarios from 'assets/img/icons/Icono-Administrar-Usuarios-Gris.png'
import icon_Administras_usuariosA from 'assets/img/icons/Icono-Administrar-Usuarios-Verde.png'
import CreaUsuario from "./CreaUsuario";


// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Modal,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Button,
  FormGroup,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { normalizeUnits } from "moment";
import { tr } from "date-fns/locale";
import basePerfiles from "./basePerfiles.js";
import baseUsuarios from "./baseUsu.js";
import { set } from "date-fns";
import baseTransaccionPen from "./baseTransaccionesPen.js";
import Compotp from "./Compotp";
import Checksantader from "./Checksantander";
import Confirmmodal from "./Confirmmodal";
import perf from "./basePerfiles.js";
import IconNid from '../../assets/img/icons/Icono-Numero-documento-Gris.png';
import IconCorreo from '../../assets/img/icons/Icono-Correo-Gris.png';
import IconNom from '../../assets/img/icons/Cliente-Gris2x.png';
import IconCel from '../../assets/img/icons/Telefono-Gris2x.png';
import IconPesos from '../../assets/img/icons/Tope_Monto_Transaccional-Gris2x.png';
import IconMas from '../../assets/img/icons/circulo-mas.png';
import IconMasRojo from '../../assets/img/icons/circulo-mas-Rojo.png';
import IconEliminar from '../../assets/img/icons/IconoEliminar.png';
import IconEliminarRojo from '../../assets/img/icons/iconoEliminarRojo.png';
import BotonEliminaIp from "./botoneliminarIp";
import Campoformato from "./campoformato";
import Transferencias from '../../assets/img/icons/Icono-Transfrencias-Multiples-Gris.png'
import TransferenciasA from '../../assets/img/icons/Icono-Transfrencias-Multiples-Verde.png'
import { event } from "jquery";
import {useDispatch} from "react-redux";
import {cambiaruta,cambiasidebar,desactivasidebar} from "../../Slicersreducers";
import Domiciliacion from "./Domiciliacion";
import ConsultaDomiciliacion from "./ConsultaDomiciliacion";
//import { Console } from "console";
const _=require("lodash");



function Security() {
  const validaIp=(ipvalor)=>{
    let valor="";
    let rango=0;
    let ipvalido=true;
    let ipajustada="";
    try{
      if(ipvalor.length>0){
        for(let i=0;i<ipvalor.length;i++){
          if(ipvalor.substr(i,1)=="."){
            rango++;
            if(parseInt(valor)>=0 && parseInt(valor)<256){
              console.log(parseInt(valor));
              ipajustada=ipajustada + parseInt(valor) + "."

            }else{
              ipvalido=false;
              console.log("error en el rango " + rango);
            }  
            valor=""
          }else if(i==ipvalor.length-1){
            valor= valor + ipvalor.substr(i,1) + ""
            rango++;
            if(parseInt(valor)>=0 && parseInt(valor)<256){
              console.log(parseInt(valor));
              ipajustada=ipajustada + parseInt(valor)
            }else{
              ipvalido=false;
              console.log("error en el rango " + rango);
            }
          }else{
            valor= valor + ipvalor.substr(i,1) + ""
          }
        }
      }
      if(rango!=4){
        ipvalido=false;
      }
      if(ipvalido){
        return {valida:ipvalido, IpAjustada:ipajustada}
      }else{
        return {valida:false, IpAjustada:""}
      }
      
    }catch{
      console.log("error en la ip");
      return {valida:false, IpAjustada:""}
    }
  }
  const enmascara=(cadena)=>{
    let n=cadena.length;
    let vista=n-4;
    let salida=""
    if(vista>=0){
        for(let i=0;i<n;i++){
            if(i>=vista){
                salida=salida + cadena.substr(i,1);
            }else{
                salida=salida + "*"
            }
        }
    }
    return salida;
  }
  const getCookie = (name) => {
    let matches = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
          name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
          "=([^;]*)"
      )
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  };
  const caracterespecial = (caracter) => {
    
    //let nuevocaracter=caracter.replace(/[ `~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "")
    let patt = new RegExp(/^[A-Za-z0-9]+$/g);
    let nuevocaracter = patt.test(caracter);
    console.log(nuevocaracter);
    if(nuevocaracter==false){
      return true;
    }else{
      return false;
    }
    
    
}
const ejecutasalir=()=>{
  setInfoModalSupervisor(false);
}
const ejecutasalirOtpProcessModal = () =>{
  setotpProcessModal(false);
  gettransactionByAuthorize();
}
    const [imagen,setImagen] = useState(icon_Administras_usuarios);
    const [imagenDomiciliacion,setImagenDomiciliacion] = useState(Transferencias);
    const [color,setColor] = useState("text-gray-dark");
    const [colorDomi,setColorDomi] = useState("text-gray-dark");
    const [colorTrans,setColorTrans] = useState("text-gray-dark");
    const [imagenTrans,setImagenTrans] = useState(icon_Administras_usuarios);
    const [activeUsu,setActiveUsu] = useState(false);
    const [activeDomi,setActiveDomi] = useState(false);
    const [activeTrans,setActiveTrans] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [activeSupervisor, setActiveSupervisor] = useState("");

    const [tipoDoc, setTipoDoc]=useState([true,false,false,false,false,false,false]);//*
    const [documento,setDocumento]=useState("");//*
    const [nameUser,setNomUsuario]=useState("");//*
    const [emailUser,setEmailUser]=useState("");//*
    const [numberMobil,setNumberMobil]=useState(0);//*
  


    const [listTransPEn,setlistTransPEn]=useState([]);
    //console.log("listado de transacciones pendientes");
    /*
    useEffect(() => {
      
    async function gettransactionByAuthorize() {
                const request = await axiosInstance()
                .get("/WSGYG39_2/api/Inquiries/transactionByAuthorize")
               /*.then((res)=>{
                  console.log("consulta lista transacciones");
                  console.log(res.data);
                  setlistTransPEn(res.data)
               })
               .catch((err) => {
                 console.log("error");
                console.log(err);
              })
              if (request != "err") {
                console.log("consulta lista transacciones");
                  console.log(request.data);
                setlistTransPEn(request.data)
              }
            }
            gettransactionByAuthorize();
          },[]);*/
             async function gettransactionByAuthorize() { 
    try{
      const request = await axiosInstance()
        .get("/WSGYG39_2/api/Inquiries/transactionByAuthorize")
      /*.then((res)=>{
          console.log("consulta lista transacciones");
          console.log(res.data);
          setlistTransPEn(res.data)
      })*/
      .catch((err) => {
        console.log("error");
        console.log(err);
      })
      console.log(request);
      if (request != undefined) {
        
        console.log("Respuesta de transacciones pendientes");
        console.log(request.data);
        setlistTransPEn(request.data)
      }
    }
    catch(e){
      return e;
    } 
    }
    async function gettransactionByAuthorize() { 
      try{
        const request = await axiosInstance()
          .get("/WSGYG39_2/api/Inquiries/transactionByAuthorize")
        /*.then((res)=>{
            console.log("consulta lista transacciones");
            console.log(res.data);
            setlistTransPEn(res.data)
        })*/
        .catch((err) => {
          console.log("error");
          console.log(err);
        })
        console.log(request);
        if (request != undefined) {
          
          console.log("Respuesta de transacciones pendientes");
          console.log(request.data);
          setlistTransPEn(request.data)
        }
      }
      catch(e){
        return e;
      } 
      }
    const CompTransPen=()=>{
      if (listTransPEn.length > 0){
        return (
          <div style={{width:"100%",
                      display:"flex",
                      flexDirection:"column",
                      justifyContent:"center",
                      alignItems:"center",
                      gap:"10px"}}>
            {
              listTransPEn.map((item,index)=>{
                return (
                  <div key={index} style={{background:"#FFFFFF",
                                          borderRadius:"10px",
                                          padding:"0.5rem",
                                          margin:"0.25rem",
                                          display:"grid",                                          
                                          gap:"1px",
                                          width:"80%"}}>
                    <div style={{gridColumn:"1",
                                gridRow:"1"}}>

                      <h3 style={{lineHeight:"2rem"}}>Origen</h3>
                      {/*<p style={{lineHeight:".5rem"}}>No. {enmascara(item.AffectedBusiness1)}</p>*/}
                      <p style={{lineHeight:".5rem"}}>No. {item.affectedBusiness1}</p>
                      <p style={{lineHeight:".5rem"}}>Sistema.{item.businessSystem1}</p>
                    </div>
                    
                    <div style={{gridColumn:"2",
                                gridRow:"1"}}>

                      <h3 style={{lineHeight:"2rem"}}>Destino</h3>
                      <p style={{lineHeight:".5rem"}}>No. {item.affectedBusiness2}</p>
                      <p style={{lineHeight:".5rem"}}>Sistema.{item.businessSystem2}</p>
                      <p style={{lineHeight:".5rem"}}>Banco {item.bank}</p>
                    </div>
                    

                    <div style={{gridColumn:"3",
                                gridRow:"1"}}>

                      <h3 style={{lineHeight:"2rem"}}>Valor {new Intl.NumberFormat("de-DE").format(item.useValue)}</h3>
                      <p style={{lineHeight:".5rem"}}>Usuario solicitante: {item.userWhoApplied}</p>
                    </div>

                    <div style={{gridColumn:"4",
                                gridRow:"1",
                                display:"flex",
                                flexDirection:"row",                                
                                alignItems:"center"}}>
                      <button className="my-btn bg-green text-white btn  btn-rounded " onClick={() => {authorize(item.cus)}}>Aprobar</button>                      
                      <button className="my-btn bg-green text-white btn  btn-rounded "onClick={() => {decline(item.cus)}}>Rechazar</button>
                    </div>
                  </div>
                )
              })
            }

          </div>
        )
      } 
      else {
        return (
          <div style={{display:"flex",justifyContent:"center",alineItems:"center"}}>
            <div style={{background:"#FFFFFF",
                                          borderRadius:"10px",
                                          padding:"2rem",
                                          margin:"1rem",
                  
                                          width:"500px"}}>
              <h1>No hay transacciones pendientes</h1>
            </div>
          </div>
          
        );
      }

    }

  //object send
  const [newUser, setNewUser] = useState({
    TidCompany: getCookie("tid"),
    NidCompany: getCookie("nid"),
    TidUser: "",
    NidUser: "",
    NameUser: "",
    EmailUser: "",
    CellNumberUser: "",
    AgencyUser: "",
    TypeUser: "4",
    PasswordConditionUser: "021",
    StatusUser: "1",
    SupervisorCode: "",
    ProfileUser: "",
    IsSupervisorUser: "",
    ListIp:[],
    idTransfer: "",
    otp: ""
  });

  const [productUser, setProductUser] = useState({
    UniqueIdUser:"",
    idTransfer: "",
    otp: "",
    ProductsUser:[]
  });

  var createReactClass = require("create-react-class");

  const [tabs, setTabs] = useState(0);

  const listStep = [
    { title: "Productos de Crédito" },
    { title: "Productos de Ahorro" },
    { title: "Despósitos a Termino" },
    { title: "Opciones Generales" },
  ];

  const listStepLine = [
    { title: "Cliente" },
    { title: "Perfil" },
    {title:"Ip"},
    { title: "Usuario Supervisor" }
    // { title: "Productos" }
  ];
  const listStepLineM = [
    { title: "Cliente" },
    { title: "Perfil" },
    //{title:"Ip"},
    { title: "Productos" }
  ];
  const [descripLineaCreacion,setdescripLineaCreacion]=useState([
    "En este espacio podrás crear o registrar un nuevo usuario. Recuerda diligenciar todos los campos y casillas.",
    "Personaliza los permisos que tendrá este nuevo usuario.",
    "Podrás registrar máximo 5 direcciones IP. Recuerda, si no ingresas ninguna IP, el usuario podrá acceder a la banca virtual sin ninguna restricción.",
    "En esta sección podrás seleccionar un usuario supervisor."
  ]);
  const [tiposIds,settiposIds]=useState(["CC","CE","NIT","TI","PS","CD","SE","FI","RCN"])
  const [tiposIdsindex,settiposIdsindex]=useState(["CC","CE","NIT","TI","PS","CD","SE","FI","RCN"])
  const [infUsuModif,setinfUsuModif]=useState({
    cellNumberUser: "",
    emailUser: "",
    isSupervisorUser: "",
    nameUser: "",
    nidUser: "",
    profileUser: "",
    statusUser: "",
    supervisorCode: "",
    tidUser: "",
    uniqueIdUser: ""
  });
  const [infUsuElim,setinfUsuElim]=useState({
    uniqueIdUser:""
  })
  const [step, setStep] = useState(0);
  const [stepLine, setStepLine] = useState(0);
  const [stepLineM, setStepLineM] = useState(0);

  const [perfiles, setperfiles] = useState(basePerfiles);

  const [moduloSelec, setModuloSelec] = useState(0);

  const [idperfilSelec, setIdperfilSelec] = useState(0);

  const [InfUsu, setInfUsu] = useState([]);  

  const [typesDocument, setTypesDocument] = useState("1");
  const [isSupervisorUser, setIsSupervisorUser] = useState();
  const [NID, setNID] = useState("802004154");

  const [product, setProduct] = useState();
  const [isSelectProduct, setIsSelectProduct] = useState(false);
  const [listProducts, setListProducts] = useState([]);
  const [uniqueIdUser, setUniqueIdUser] = useState("");
  const [infoModalSupervisor, setInfoModalSupervisor] = useState(false);
  const [consultaDomiciliacion, setConsultaDomiciliacion] = useState([]);
  const [indicadoretapa,setindicadoretapa]=useState(0);

  const [maximunTransaction, setMaximunTransaction] = useState(0);

  const [supervisorUsers, setSupervisorUsers] = useState([]);
  /*const [supervisorUsers, setSupervisorUsers] = useState([
    {
      id: "1",
      ownerAccount: "Diego Torres",
    },
    {
      id: "2",
      ownerAccount: "Alejandro Niño",
    },
    {
      id: "3",
      ownerAccount: "Jazmin Torres",
    },
  ]);*/

  const refNid = useRef(null);
  const refName = useRef(null);
  const refEmail = useRef(null);
  const refCellNumber = useRef(null);

  const refMaxValue = useRef(null);
  const refMaxDailyValue = useRef(null);
  //const refMaxDailyValue =React.createRef();
  const refModifNombre=useRef(null);
  const refIps=useRef(null);

  const [productState, setProductState] = useState("");
  const [productValidation, setProductValidation] = useState("");
  const [resultModal, setResultModal] = useState(false);
  const [otpcreacionusu,setotpcreacionusu]=useState(false);
  const [cargandootpcreausu,setcargandootpcreausu]=useState(true);
  const [checkSupervisor,setCheckSupervisor] = useState(false);
  const [listSelected, setListSelected] = useState([]);

  const [auxNidUser, setAuxNidUser] = useState("");
  // const [auxNameUser, setAuxNameUser]= useState("");
  // const [auxEmailUser,setEmailUser] = useState(refEmail.current.value);
  // const [auxCellNumberUser,setAuxCellNumberUser] = useState(refCellNumber.current.value);
  // const [auxTidUser,SetAuxTidUser] = useState(typesDocument);
  // const [auxIsSupervisorUser, SetAuxIsSupervisorUser] = useState(isSupervisorUser);
  const [nombreUsuario,setNombreUsuario] = useState("");
  const [otpelimusu,setotpelimusu]=useState(false);
  const [cargandootpelimusu,setcargandootpelimusu]=useState(true);
  const [permisos,setpermisos]=useState(basePerfiles);
  const [listAlert, setListAlert] = useState([]);
  const [keyAlert,setkeyAlert]=useState([]);
  const [funcionalidadHabil,setfuncionalidadHabil]=useState(0);
  const [idtransfer,setidtransfer]=useState("");
  const [checkproducto,setcheckproducto]=useState([]);
  const [permisosProd,setpermisosProd]=useState({
      maxDaily:"",
      maxTransaction:"",
      otp:false,
      supervisor:false,
      consulta:false,
      transaccion:false
    })
  const [permisosguardados,setpermisosguardados]=useState([]);
  const [tidelec,settidelec]=useState([false,false,false,false,false,false,false]);
  const [estadoIconIpAgrega,setestadoIconIpAgrega]=useState(IconMas);
  const [valorIp,setvalorIp]=useState([]);
  const dispatch=useDispatch();

  const [mensconfirmbloqueoUsu,setmensconfirmbloqueoUsu]=useState("Desea bloquear el usuario");
  const [confirmbloqueo,setconfirmbloqueo]=useState(false);
  const [userBloqydesbloq,setuserBloqydesbloq]=useState({
    tidUser: "",
    nidUser: "",
    operation:-1
  });
  const [codigobloqUsu,setcodigobloqUsu]=useState(-1);

  const [mensconfirmdesblocUsu,setmensconfirmdesblocUsu]=useState("Desea desbloquear el usuario");
  const [confirmdesbloc,setconfirmdesbloc]=useState(false);
  const [loadOtpAuthorize,setloadOtpAuthorize]=useState(false);
  const [otpAuthorize,setotpAuthorize]=useState(false);
  const [otpIdTransfer, setotpIdTransfer]=useState("");
  const [otpProcessModal,setotpProcessModal]=useState(false); 
  const [confirmDecline,setconfirmDecline]=useState(false);
  const [cusDecline,setcusDecline]=useState("");
  const [authorizationStatus,setauthorizationStatus]=useState("");
  const [flujodomiciliacion,setflujodomiciliacion]=useState("");
  const [objinidomi,setobjinidomi]=useState({});
  const [notificadomi,setnotificadomi]=useState(false);
  const [mensajenotifdomi,setmensajenotifdomi]=useState("");


  const pideconfirmbloqueousu=(usu,tid,nid,codigounico)=>{
    setmensconfirmbloqueoUsu("Desea bloquear el usuario " + usu);
    console.log("tid " + tid + " nid " + nid);
    setuserBloqydesbloq({
      tidUser: tid,
      nidUser: nid,
      operation:2});
    setconfirmbloqueo(true);
    setcodigobloqUsu(codigounico);
  }
  const RequestOTPTransfer= {
    IdTransfer:"",    
    Otp:""
    }
  async function responseotpAuthorize(code) {
    //RequestOTPTransfer.IdTransfer=transcode;

    if(code.length>0)
    {
      RequestOTPTransfer.IdTransfer=otpIdTransfer;
      RequestOTPTransfer.Otp=code;
      
      //console.log("ref1:" + ref1);
      //RequestOTPTransfer.Otp=
      //ref1 +""+ ref2+""+ ref3+""+ ref4+""+ ref5+""+ ref6+"";
      let codigoSR05012=false;    
      console.log("valido " + RequestOTPTransfer.Otp)
      const request = await axiosInstance().post("/WSGYG39_2/api/Transaction/ValidOtp",RequestOTPTransfer)
        .catch(err => {
          gettransactionByAuthorize();
          setotpAuthorize(false);
          setauthorizationStatus("Rechazada");
          setotpProcessModal(true);
          if (err.response.data.errors) {
            setListAlert(
              err.response.data.errors.map((o) => ({
                ...o,
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle",
              }))
            );
            err.response.data.errors.map((o)=>{
              if(o.code=="SR05012"){
                codigoSR05012=true;// numero intentos excedido 
              }
            })
          } else {
            codigoSR05012=true;
            setListAlert([
              {
                description: "No se pudo autorizar la transacción.",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle"
              }
            ]);
          }
          console.log("Error del consumo valida otp")
          return 'err';
        });
        console.log("respuesta valida otp");
        console.log(request);
      if (request != 'err') {      
        console.log("respuesta : " + request.data.plot);
        setauthorizationStatus("Aprobada");
        setotpAuthorize(false);
        setotpProcessModal(true);
      } else {  
        // 
        //console.log("respuesta indicador : " + request.data.page);
        if(codigoSR05012){          
          setotpAuthorize(false);//ocultar modal 
        }    
      }
    }else
    {
      setotpAuthorize(false);
    }
  }
  const confirmaBloqueoUsu=async(confirma)=>{
    console.log(userBloqydesbloq);
    console.log(confirma);
    setconfirmbloqueo(false);
    if(confirma){
      const request= await axiosInstance().post("/WSGYG39_2/api/Users/LockUnlockUsers",userBloqydesbloq).catch((err) => {
        console.log(err);
        if (err.response.data.errors) {
          setListAlert(
            err.response.data.errors.map((o) => ({
              ...o,
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle",
            }))
          );
        } else {
          setListAlert([
            {
              description: "No se pudo bloquear el usuario debido a un problema.",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle"
            }
          ]);
        }
        return "err";
      });
      if (request != "err") {//agregar mensaje de exito dependiendo respuesta 
        console.log(request);
        if (request.data.errors) {
          setListAlert(
            request.data.errors.map((o) => ({
              ...o,
              type: "alert alert-alert show alert-dismissible fade alert-success",
              icon: "fas fa-check-circle",
            }))
          );
        } else {
          setListAlert([
            {
              description: "Usuario bloqueado correctamente",
              type: "alert alert-alert show alert-dismissible fade alert-success",
              icon: "fas fa-check-circle",
            },
          ]);
        }
        let lista_Usuarios=_.cloneDeep(InfUsu);
        for(let i=0;i<lista_Usuarios.length;i++){
          if(lista_Usuarios[i].uniqueIdUser==codigobloqUsu){
            lista_Usuarios[i].statusUser="BLOQUEADO";
            i=lista_Usuarios.length;
          }
        }
        setInfUsu(_.cloneDeep(lista_Usuarios)); 
      }
      
    }
    setcodigobloqUsu(-1);
    setuserBloqydesbloq({
      tidUser: "",
      nidUser: "",
      operation:-1});
  }
  const cambiaTabDomi=(tipoeleg,dataini={}) =>{
    console.log("consulta domi");
    console.log(dataini)
       console.log("tipo de flujo " + tipoeleg);
       if(tipoeleg=="modificadomi"){
          setobjinidomi(dataini);
          console.log("set dataini")
       }else{
        setobjinidomi({});
       }
       setflujodomiciliacion(tipoeleg);
       setTabs(10);
  }
  const limpianotificaciondomi=()=>{
    setnotificadomi(false);
  }

  const pideconfirmdesblocousu=(usu,tid,nid,codigounico)=>{
    setmensconfirmdesblocUsu("Desea desbloquear el usuario " + usu);
    console.log("tid " + tid + " nid " + nid);
    setuserBloqydesbloq({
      tidUser: tid,
      nidUser: nid,
      operation:1});
    setconfirmdesbloc(true);
    setcodigobloqUsu(codigounico);
  }
  const confirmaDesblocUsu=async(confirma)=>{
    console.log(userBloqydesbloq);
    console.log(confirma);
    setconfirmdesbloc(false);
    if(confirma){
      const request= await axiosInstance().post("/WSGYG39_2/api/Users/LockUnlockUsers",userBloqydesbloq).catch((err) => {
        console.log(err);
        if (err.response.data.errors) {
          setListAlert(
            err.response.data.errors.map((o) => ({
              ...o,
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle",
            }))
          );
        } else {
          setListAlert([
            {
              description: "No se pudo desbloquear el usuario debido a un problema.",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle"
            }
          ]);
        }
        return "err";
      });
      if (request != "err") {//agregar mensaje de exito dependiendo respuesta 
        console.log(request);
        if (request.data.errors) {
          setListAlert(
            request.data.errors.map((o) => ({
              ...o,
              type: "alert alert-alert show alert-dismissible fade alert-success",
              icon: "fas fa-check-circle",
            }))
          );
        } else {
          setListAlert([
            {
              description: "Usuario desbloqueado correctamente",
              type: "alert alert-alert show alert-dismissible fade alert-success",
              icon: "fas fa-check-circle",
            },
          ]);
        }
        let lista_Usuarios=_.cloneDeep(InfUsu);
        for(let i=0;i<lista_Usuarios.length;i++){
          if(lista_Usuarios[i].uniqueIdUser==codigobloqUsu){
            lista_Usuarios[i].statusUser="ACTIVO";
            i=lista_Usuarios.length;
          }
        }
        setInfUsu(_.cloneDeep(lista_Usuarios)); 
      }
      
    }
    setcodigobloqUsu(-1);
    setuserBloqydesbloq({
      tidUser: "",
      nidUser: "",
      operation:-1});

  }
  useEffect(async() => {
    
    
    const timer = setTimeout(deleteElementFromArr, 5000);
    return () => clearTimeout(timer);
  });
  
  const deleteElementFromArr = () => {
    
    if (listAlert.length > 0) {
      let temp = listAlert.slice();
      temp.splice(0, 1);
      setListAlert(temp);
    }
  };

  
  // const deleteElementFromArr = (lista) => {
  //   console.log("tarea automatica");
  //   console.log(lista);
  //   if (listAlert.length > 0) {
  //     let temp = listAlert.slice();
  //     console.log(temp);
  //     temp.splice(0, 1);
  //     setListAlert(temp);
  //   }
  // };
  const deleteAlert = (alert) => {

    console.log("elimina alerta");
    console.log(listAlert);
    setListAlert(listAlert.filter((auxAlert) => auxAlert != alert));
  };
  var Alerts = createReactClass({
    render: function () {
      var data = this.props.data;
      var newsTemplate;
      if (data.length > 0) {
        newsTemplate = data.map(function (item, index) {
          return (
            <div class={item.type} role="alert">
              <button
                type="button"
                class="close"
                aria-label="Close"
                onClick={() => deleteAlert(item)}
              >
                <span aria-hidden="true">×</span>
              </button>
              <span className="alert-inner--icon mr-3">
                <i className={item.icon} />
              </span>{" "}
              <span class="alert-inner--text">{item.description}</span>
            </div>
          );
        });
      }
      return <div className="toast-bottom-right">{newsTemplate}</div>;
    },
  });

  
  const escuchaCheck=(idCheck,estado)=>{
    
    let estadoperfiles=_.cloneDeep(perfiles);
    if(perfiles.length>0){
      for(let i=0;i<perfiles.length;i++){
        if(perfiles[i].id==idCheck){
          estadoperfiles[i].habilitado=estado;
          //i=perfiles.length;
        }else{
          estadoperfiles[i].habilitado=false;
          //i=perfiles.length;
        }
      }
      setperfiles(_.cloneDeep(estadoperfiles));
    }
    console.log(perfiles);
    console.log("Check " + idCheck + " estado " + estado);
  }

  // const handleChangeRemove = (item) => () => {
  //   setListSelected((items) => perfiles.filter((i) => i.id !== item.id));
  //   console.log("entra a handleChangeRemove")
  // };
  // const handleChangeSelect = (items) => () => {
  //   setListSelected([...listSelected, items]);
  //   console.log("entra a handleChangeSelect")
  // };
  // const isSelected = ({ item }) => perfiles.some((i) => i.item === item);
  

  const pideotpcreacionusu=async()=>{
    let hayproductos=false;
    let productoshabiles=true;
    let alertaprod=false;
    let alertausu="";
    for(let item=0;item<checkproducto.length;item++){
      if(checkproducto[item]){
        alertaprod=false;
        hayproductos=true;
        alertausu="El producto " + enmascara(listProducts[item].accountNumber) + ", ";
        if(permisosguardados[item].otp || permisosguardados[item].supervisor){
          
        }else{
          productoshabiles=false;
          alertaprod=true;
          alertausu=alertausu + " debe tener una opcion de validacion seleccionada, ";
        }
        if(permisosguardados[item].consulta || permisosguardados[item].transaccion){

        }else{
          productoshabiles=false;
          alertaprod=true;
          alertausu=alertausu + " debe tener una opcion de accion seleccionada."
        }
        let nummaxdaily=Number(permisosguardados[item].maxDaily.replace(/,/gi ,""));
        let nummaxtrans=Number(permisosguardados[item].maxTransaction.replace(/,/gi ,""));
        console.log("maxdaily numero " + nummaxdaily);
        if(nummaxtrans>nummaxdaily){
          alertausu=alertausu + " El tope de monto maximo debe ser menor al tope diario."
        }

        if(alertaprod){
          setListAlert([
            {
              description: alertausu,
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle"
            }
          ]);

        }
        
        /*
        atributosProd={
          accountNumber: listProducts[item].accountNumber,
          accountSystem: listProducts[item].accountsystem,
          description: listProducts[item].description,
          isSelectProduct: checkproducto[item],
          action: actionedit,
          validation: validationedit,
          maxDaily: permisosguardados[item].maxDaily,
          maxTransaction: permisosguardados[item].maxTransaction
        }*/

      }
    }
    //if(hayproductos ){
      //if(productoshabiles){
        setotpcreacionusu(true);
        let bodyotp={
          UniqueIdUser:newUser.NidUser
        }
        console.log("uniqueIdUser: " + bodyotp.UniqueIdUser);
        const request = await axiosInstance().post("/WSGYG39_2/api/Inquiries/GenerateOTP",bodyotp)
          .catch((err) => {
            console.log(err);
            if (err.response.data.errors) {
              setListAlert(
                err.response.data.errors.map((o) => ({
                  ...o,
                  type: "alert alert-alert show alert-dismissible fade alert-danger",
                  icon: "fas fa-exclamation-circle",
                }))
              );
            } else {
              setListAlert([
                {
                  description: "Hubo un problema con el envió de la clave temporal.",
                  type: "alert alert-alert show alert-dismissible fade alert-danger",
                  icon: "fas fa-exclamation-circle"
                }
              ]);
            }
            setotpcreacionusu(false);
            return "err";
          });
        if (request != "err") {//agregar mensaje de exito dependiendo respuesta 
          console.log(request);
          setidtransfer(request.data.idTransfer);
          setcargandootpcreausu(false);
        }

     // }
      
    // }else{
    //   setListAlert([
    //     {
    //       description: "El usuario no tiene permisos sobre ningún producto.",
    //       type: "alert alert-alert show alert-dismissible fade alert-danger",
    //       icon: "fas fa-exclamation-circle"
    //     }
    //   ]);
    // }
  }  
  const respuestaotpcreacionusu=async(otprecibido)=>{
    setotpcreacionusu(false);
    if(otprecibido.length>0){
      console.log("padre :" + otprecibido);
      //setTabs(6);
      newUser.idTransfer=idtransfer;
      newUser.otp=otprecibido;
      console.log("Usuario a crear");
      console.log(newUser);
      const request = await axiosInstance()
        .post("/WSGYG39_2/api/Inquiries/CreateUser", newUser)
        .catch((err) => {
          console.log(err);
          if (err.response.data.errors) {
            setListAlert(
              err.response.data.errors.map((o) => ({
                ...o,
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle",
              }))
            );
          } else {
            setListAlert([
              {
                description: "Error de la clave temporal",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle"
              }
            ]);
          }
          return "err";
        });
      if (request != "err") {
        
        console.log("respuesta creacion de usuarios")
        console.log(request);
        setUniqueIdUser(request.data.uniqueIdUser);
        console.log("uniqueIdUser: " + uniqueIdUser);
        console.log("envio final creacion de usuario");
        console.log(listProducts.filter((item) => item.isSelectProduct));
        productUser.UniqueIdUser=request.data.uniqueIdUser;
        productUser.idTransfer=idtransfer;
        productUser.otp=otprecibido;

        let lista_usuario=_.cloneDeep(InfUsu);
          lista_usuario.push({
            cellNumberUser: newUser.CellNumberUser,
            emailUser:newUser.EmailUser,
            isSupervisorUser:newUser.IsSupervisorUser,
            listIp:newUser.ListIp,
            nameUser: newUser.NameUser,
            nidUser: newUser.NidUser,
            profileUser: newUser.ProfileUser,
            statusUser: "ACTIVO",
            supervisorCode:newUser.SupervisorCode,
            tidUser: newUser.TidUser,
            uniqueIdUser: request.data.uniqueIdUser
          })
          setInfUsu(_.cloneDeep(lista_usuario));
          

          setResultModal(true);
          setidtransfer("");
          setTabs(4)
        }
        //let copialistaproductos=_.cloneDeep(listProducts);
        /*for(let i=0;i<checkproducto.length;i++){
          if(checkproducto[i]){
            listProducts[i].isSelectProduct=true;
          }
        }*/
        //productUser.ProductsUser=listProducts.filter((item) => item.isSelectProduct);
        //productUser.ProductsUser=listProducts.filter((item,index) => checkproducto[index]);

        //************Comentado solo para IDEA ***************************/
        // let atributosProd;
        // let actionedit;
        // let validationedit;
        // let productosselecedit=[];
        // console.log("lista de productos");
        // console.log(listProducts)
        // for(let item=0;item<checkproducto.length;item++){
        //   if(checkproducto[item]){
        //     if(permisosguardados[item].otp){
        //       validationedit="N";

        //     }
        //     if(permisosguardados[item].supervisor){
        //       validationedit="S";
        //     }
        //     if(permisosguardados[item].consulta){
        //       actionedit="C";

        //     }
        //     if(permisosguardados[item].transaccion){
        //       actionedit="T";
        //     }
        //     atributosProd={
        //       accountNumber: listProducts[item].accountNumber,
        //       accountSystem: listProducts[item].accountsystem,
        //       description: listProducts[item].description,
        //       isSelectProduct: checkproducto[item],
        //       action: actionedit,
        //       validation: validationedit,
        //       maxDaily: permisosguardados[item].maxDaily,
        //       maxTransaction: permisosguardados[item].maxTransaction
        //     }
        //     productosselecedit.push(JSON.parse(JSON.stringify(atributosProd)));
        //   } 
        // }
        // productUser.ProductsUser=_.cloneDeep(productosselecedit);
        // console.log(checkproducto)
        // console.log(productUser);
        // const request2 = await axiosInstance()
        //   .post(
        //     "/WSGYG39_2/api/Inquiries/CreateUserProducts",
        //     productUser
        //   )
        //   .catch((err) => {
        //     if (err.response.data.errors) {
        //       setListAlert(
        //         err.response.data.errors.map((o) => ({
        //           ...o,
        //           type: "alert alert-alert show alert-dismissible fade alert-danger",
        //           icon: "fas fa-exclamation-circle",
        //         }))
        //       );
        //     } else {
            
        //       setListAlert([
        //         {
        //           description: "Error de la clave temporal",
        //           type: "alert alert-alert show alert-dismissible fade alert-danger",
        //           icon: "fas fa-exclamation-circle"
        //         }
        //       ]);
        //     }
        //     return "err";
        //   });
        // if (request2 != "err") {//agregar mensaje de exito dependiendo respuesta 
        //   setListAlert([
        //     {
        //       description: "Usuario creado correctamente",
        //       type: "alert alert-alert show alert-dismissible fade alert-success",
        //       icon: "fas fa-check-circle",
        //     },
        //   ]);
        //   let lista_usuario=_.cloneDeep(InfUsu);
        //   lista_usuario.push({
        //     cellNumberUser: newUser.CellNumberUser,
        //     emailUser:newUser.EmailUser,
        //     isSupervisorUser:newUser.IsSupervisorUser,
        //     listIp:newUser.ListIp,
        //     nameUser: newUser.NameUser,
        //     nidUser: newUser.NidUser,
        //     profileUser: newUser.ProfileUser,
        //     statusUser: "ACTIVO",
        //     supervisorCode:newUser.SupervisorCode,
        //     tidUser: newUser.TidUser,
        //     uniqueIdUser: request.data.uniqueIdUser
        //   })
        //   setInfUsu(_.cloneDeep(lista_usuario));
          

        //   setResultModal(true);
        //   setidtransfer("");
        //   setTabs(4);
        // }
      
    }
  }
  const iniciocreaUsu=async()=>{
    setotpelimusu(false);
    const request = await axiosInstance()
      .get("/WSGYG39_2/api/Inquiries/Products")
      .catch((err) => {
        return "err";
      });
    if (request != "err") {
      
      let creaprodUsu=[];
      let atributosProd;
      let checkxprod=[];
      let inipermisos=[];
      if(request.data.summaryProducts.products.length>0){
        for(let i=0;i<request.data.summaryProducts.products.length;i++){
          atributosProd={
            accountNumber: request.data.summaryProducts.products[i].accountNumber,
            accountsystem: request.data.summaryProducts.products[i].system,
            description: request.data.summaryProducts.products[i].description,
            isSelectProduct: false
          }
          creaprodUsu.push(atributosProd);
          checkxprod.push(false);
          inipermisos.push(permisosProd);
        }
      }
      console.log(_.cloneDeep(creaprodUsu));
      setListProducts(_.cloneDeep(creaprodUsu));
      setcheckproducto([...checkxprod]);
      setpermisosguardados(_.cloneDeep(inipermisos));
      setTabs(6);
    }
  }
  
  const respuestaotpelimusu=async(otprecibido)=>{
   
    if(otprecibido.length>0){
      console.log("padre :" + otprecibido);
      console.log("/WSGYG39_2/api/Inquiries/DeleteUser/" + infUsuElim.uniqueIdUser + "/" + idtransfer + "/" + otprecibido);
      const request = await axiosInstance().delete("/WSGYG39_2/api/Inquiries/DeleteUser/" + infUsuElim.uniqueIdUser + "/" + idtransfer + "/" + otprecibido)
        .catch((err) => {
          console.log(err);
          if (err.response.data.errors) {
            setListAlert(
              err.response.data.errors.map((o) => ({
                ...o,
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle",
              }))
            );
          } else {
            setListAlert([
              {
                description: "No se pudo eliminar el usuario debido a un problema.",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle"
              }
            ]);
          }
          setotpelimusu(false);
          setidtransfer("");
          return "err";
        });
      if (request != "err") {//agregar mensaje de exito dependiendo respuesta 
        console.log(request);
        setidtransfer("");
        setotpelimusu(false);
        getUsers();
        if (request.data.errors) {
          setListAlert(
            request.data.errors.map((o) => ({
              ...o,
              type: "alert alert-alert show alert-dismissible fade alert-success",
              icon: "fas fa-check-circle",
            }))
          );
        } else {
          setListAlert([
            {
              description: "Usuario eliminado correctamente",
              type: "alert alert-alert show alert-dismissible fade alert-success",
              icon: "fas fa-check-circle",
            },
          ]);
        }

        let lista_Usuarios=_.cloneDeep(InfUsu);
        for(let i=0;i<lista_Usuarios.length;i++){
          if(lista_Usuarios[i].uniqueIdUser==infUsuElim.uniqueIdUser){
            lista_Usuarios[i].statusUser="ELIMINADO";
            i=lista_Usuarios.length;
          }
        }
        setInfUsu(_.cloneDeep(lista_Usuarios));
      }
    }
    setotpelimusu(false);

  }
  // Stepper

  function Progress(props) {
    const styleProgress = { width: 100 / props.list.length - 2 + "%" };
    var newsTemplate = props.list.map(function (item, index) {
      if (index === props.current) {
        return (
          <div
            key={index}
            className="progress-bar-step-active"
            style={styleProgress}
          >
            <span className="stepper-number-active">
              <span className="stepper-label-active">{index + 1}</span>
            </span>
          </div>
        );
      } else {
        return (
          <div key={index} className="progress-bar-step" style={styleProgress}>
            <span className="stepper-number">
              <span className="stepper-label">{index + 1}</span>
            </span>
          </div>
        );
      }
    });
    return newsTemplate;
    
  }
  
  

  function LineStepper(props) {
    return (
      <>
        <div style={{ position: "relative" }} className="mt-1 m-4 mb-6">
          <div style={{ position: "absolute", width: "100%" }}>
            <Progress current={props.current} list={props.listStep}></Progress>
          </div>
        </div>
      </>
    )
  }
  const [maxstepcreaUsu,setmaxstepcreaUsu]=useState(0);
  const controlesCreaUsu=(etapa,sentido)=>{
    console.log("etapa " + etapa + " sentido " + sentido);
    console.log(maxstepcreaUsu)
    if(sentido==1){
      if(etapa+1 <= maxstepcreaUsu && etapa>0){
        if(etapa<2){
          setStepLine((s) => s + 1);
        }else{
          if(newUser.IsSupervisorUser=="N"){
            setStepLine((s) => s + 1);
          }else{
            if(etapa+2 <= maxstepcreaUsu){
              setStepLine((s) => s + 2);
            }
          }
        }
      }
    }else{
      if(etapa-1 >=0){
        if(etapa<4){
          setStepLine((s) => s - 1);
        }else{
          if(newUser.IsSupervisorUser=="N"){
            setStepLine((s) => s - 1); 
          }else{
            setStepLine((s) => s - 2);
          }
        }
      }
    }
  }
  function NavigationButtons(props) {
    var isFirst=true;
    if(props.step > 0){
      isFirst=false;
    }
    var isEnd = props.step === props.listStep.length - 1;
    /*onClick={()=>{controlesCreaUsu(stepLine,-1)}}*/
    /*onClick={()=>{controlesCreaUsu(stepLine,1)}}*/
    //disabled={!isEnd}
    //disabled={!isFirst}
    return (
      
      <div style={{ justifyContent: "space-between", display: "flex" }}>
        <button  class="btn-icon text-dark-grey btn" disabled={isFirst} onClick={()=>{controlesCreaUsu(stepLine,-1)}}>
          <span class="btn-inner--icon">{"<"}</span>
          <span class="btn-inner--text">
            {isFirst ? "Volver" : props.listStep[props.step - 1].title}
          </span>
        </button>
        <button class="btn-icon text-dark-grey btn" disabled={isEnd} onClick={()=>{controlesCreaUsu(stepLine,1)}}>
          <span class="btn-inner--text">
            {isEnd ? "Cancelar" : props.listStep[props.step + 1].title}
          </span>
          <span class="btn-inner--icon">{">"}</span>
        </button>
      </div>
    );
  }

  function DivStep({ children }) {
    return <>{children}</>;
  }

  function Step(props) {
    if (props.current === props.step) {
      return (
        <div
          className="radius-middle active shadow p-3 mt-4 mb-4 text-center text-green cursor-pointer col"
          onClick={() => setStep(props.step)}
        >
          {props.label}
        </div>
      );
    } else {
      return (
        <div
          className="radius-middle shadow p-3 mt-4 mb-4 text-center text-green cursor-pointer col"
          onClick={() => setStep(props.step)}
        >
          {props.label}
        </div>
      );
    }
  }

  function TabStepper(props) {
    console.log("isSupervisorUser")
    console.log(newUser.IsSupervisorUser);
      var newsTemplate = props.listStep.map(function (item, index) {
        return (
          <Step
            key={index}
            current={props.current}
            step={index}
            label={item.title}
          />
        );
      });
      return (
        <>
          <Row>{newsTemplate}</Row>
        </>
      );

    }
    
  

  function DivStepper({ children, ...props }) {
    const childrenArray = React.Children.toArray(children);

    const currentChild = childrenArray[props.step];
    if (props.type === "tab") {
      return (
        <div {...props}>
          <TabStepper
            current={props.step}
            listStep={props.listStep}
          ></TabStepper>
          {currentChild}
        </div>
      );
    } else if (props.type === "line") {
      return (
        <div {...props}>
          <NavigationButtons
            tab={props.tab}
            step={props.step}
            listStep={props.listStep}
          ></NavigationButtons>
          <LineStepper
            current={props.step}
            listStep={props.listStep}
          ></LineStepper>
          <div className="text-center m-4">
            <h2 class="ml-2">{props.listStep[props.step].title}</h2>
          </div>
          {currentChild}
        </div>
      );
    } else return <></>;
  }

  //const [count]=useState(0);
  async function getUsers() {
       
    const request = await axiosInstance()
      .get("/WSGYG39_2/api/Inquiries/ListUsers")
      .catch((err) => {
        return "err";
      });
    if (request != "err") {
      console.log("caraga useeffect");
      console.log(request.data);
      setInfUsu(request.data );
    }
    //return request ;
  } 

  //const [count]=useState(0);
  useEffect(() => {
    dispatch(cambiaruta("Inicio/Seguridad"));
    dispatch(cambiasidebar(false));
    dispatch(desactivasidebar([false,false]))
   
  
    const perfilCookie=getCookie("TEMPORAL");
    console.log("cookie temporal " + perfilCookie);
    let permitido=false;
    if (perfilCookie){
      for(let i=0;i<perfiles.length;i++){
        if(perfiles[i].nombrePerfil=="Seguridad"){
          if(perfilCookie.substring(i,1)=="1"){
            console.log("Perfil habilitado");
            permitido=true;
          }else{
            console.log("perfil inhabilitado");
            permitido=false;
          }
          i=perfiles.length;
        }
      }
    }else{
      console.log("no se encuetra cookie");
      permitido=false;
    }
    if(permitido){
      //gettransactionByAuthorize();
      getUsers(); 
      setfuncionalidadHabil(1);
    }else{
      setfuncionalidadHabil(2);
    }
  },
    [4]
  );// [count]);

  async function authorize(cus) 
  {     
      setotpIdTransfer(cus);
      setotpAuthorize(true);
      setloadOtpAuthorize(true);// mostrar cargando
    
    
    try{
      const request = await axiosInstance()
        .get("/WSGYG39_2/api/Inquiries/authorizeTransaction/"+ cus + "/S")     
      .catch((err) => {
        console.log("error");
        console.log(err);
        if (err.response.data.errors) {
          setListAlert(
            err.response.data.errors.map((o) => ({
              ...o,
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle",
            }))
          );}
          return "err";
      })
      console.log(request);
      if (request != "err") {
        setloadOtpAuthorize(false);
        console.log("Respuesta de transacciones pendientes");
        console.log(request.data);
        //setlistTransPEn(request.data)
      }
    }
    catch(e){
      return e;
    } 
  }
  async function declineTransaccion(option)
  {
    console.log("option decline" + option);
    if (option)
    {
      
      //setconfirmDecline(false);
      try{
        const request = await axiosInstance()
          .get("/WSGYG39_2/api/Inquiries/authorizeTransaction/"+ cusDecline + "/N")
        .catch((err) => {
          if (err.response.data.errors) {
            setListAlert(
              err.response.data.errors.map((o) => ({
                ...o,
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle",
              }))
            );}
            return "err";
        })
        console.log(request);
        if (request != "err") {
          //setloadOtpAuthorize(false);
          console.log("Respuesta de transacciones pendientes");
          console.log(request.data);
          setconfirmDecline(false);
          setauthorizationStatus("Rechazada");
          setotpProcessModal(true);
          //setlistTransPEn(request.data)
        }
      }
      catch(e){
        return e;
      }

    }else
    {
      setconfirmDecline(false);      
    }
     
  }
  async function decline(cus) 
  {     
    setcusDecline(cus);
    setconfirmDecline(true);        
  }
  //TypeDocument
  function getTypeDocument(event) {
    //auxBuildAccount.accountType = type;
    //setNewUser({...newUser, TidUser: type});
    setTypesDocument(event.target.value);
    console.log(event.target.value);
      switch(event.target.value){
        case "1":
          settidelec([true,false,false,false,false,false,false]);

          break;
        case "2":
          settidelec([false,true,false,false,false,false,false]);

          break;
        case "3":
            settidelec([false,false,true,false,false,false,false]);

        break;
        case "5":
          settidelec([false,false,false,true,false,false,false]);

        break;
        case "6":
          settidelec([false,false,false,false,true,false,false]);

        break;
        case "8":
          settidelec([false,false,false,false,false,true,false]);

        break;
        case "9":
          settidelec([false,false,false,false,false,false,true]);
        break;

      }
  }

  //Supervisor
  async function getIsSupervisor(type) {
    //auxBuildAccount.accountType = type;
    //setNewUser({...newUser, IsSupervisorUser: type});
    setAuxNidUser(refNid.current.value);
    await setIsSupervisorUser(type);
  }
  

  //NID
  const NIDChange = (event) => {
    setNID(event.target.value);
  };
  const NidChange = () => {
  setAuxNidUser(refNid.current.value);
  refNid.current.focus();
   
  };
  // const NameChange = () => {
  //   setAuxNameUser(refName.current.value);
  //   refName.current.focus();
   
  // };



  //Maximun Transaction
  const handleChangeMinimum = (event) => {
    product.minValue = event.target.value;
  };

  //Maximun Daily
  const handleChangeMaximum = (event) => {
    product.maxValue = event.target.value;
  };

  //Maximun Transaction
  const cambioTopetotal = (event) => {
    event.preventDefault();
    let val = event.target.value;
    //setmaxTransaction(val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    setmaxTransaction(event.target.value);
    //console.log(topesxprod);
    //refMaxValue.current.focus();
  };

  const cambioTopediario = (event) => {
    event.preventDefault();
    let val = event.target.value;
    setmaxDaily(val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    //console.log(topesxprod);
    refMaxDailyValue.current.focus();
  };

  //Maximun Daily
  const handleChangeMaximunDaily =(event) => {
    //settopesxprod({...topesxprod, maxDaily: event.target.value});
    event.preventDefault();
    let val = event.target.value;
    if(topeMD==1){
      setmaxDaily(val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","));
      settopesxprod({...topesxprod ,maxTransaction:val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")});
      console.log(topesxprod);
      product.maxTransaction =val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }else{
      setmaxDaily(val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","));
      settopesxprod({...topesxprod ,maxDaily: val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")});
      console.log(topesxprod);
      product.maxDaily =val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
  //Products
  const [OpcProdSelec,setOpcProdSelec]=useState(-1);
  const Products =(props)=>{
      var data = props.data;
      var tab = props.tab;
      var newsTemplate;

      if (data.length > 0) {
        newsTemplate = data.map(function (item, index) {
          return (
            <Row key={item.accountNumber} >
              <CardAccount data={item} tab={tab} index={index} />
              {/*<OptionsProducts producto={index}></OptionsProducts>*/}
            </Row>
          );
        });
      } else {
        newsTemplate = (
          <Skeleton
            height={100}
            count={4}
            className="card-transaction-info"
            style={{ width: "-webkit-fill-available" }}
          ></Skeleton>
        );
      }
      return <div>{newsTemplate}</div>;
  };
  const escuchaprodselec=(idprod,estado)=>{
    console.log("La cuenta " + idprod + " esta en " + estado);
    let copiachecks=[...checkproducto];
    copiachecks[idprod]=estado;
    setcheckproducto([...copiachecks]);
    console.log(checkproducto);
  }
  var CardAccount = createReactClass({
    render: function () {
      var accountNumber =
        this.props.data.accountNumber,
        description = this.props.data.description,
        selectProduct = this.props.data.isSelectProduct;
      return (
        <Col lg="12" xl="12" className="pt-3">
          <Card className="mb-xl-0 cursor-pointer bordeHover" >
            
            <CardBody className="p-2">
              <Row >
                <div onClick={()=>getProduct(this.props.data, this.props.tab,this.props.index)} className="col-auto ml-4 p-1" style={{ width: "80%" }}>
                  <Row>
                    <span class="mb-0">
                      {description} <br /> No. {accountNumber}
                    </span>
                  </Row>
                </div>
                <div className="ml-3">
                  {/*
                  <input
                    className="my-custom-control-input"
                    id="customCheck5"
                    type="checkbox"
                    onChange={() => handleChangeIsSelectedProduct(this.props.indexprod)}
                    checked={selectProduct}
                    disabled={!(product === this.props.data)}
                  />*/}
                  <Checksantader mensaje={""} estadocheck={checkproducto[this.props.index]} idCheck={this.props.index} funcionpadre={escuchaprodselec}></Checksantader>
                </div>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    },
  });
  const [topesxprod,settopesxprod]=useState({
    maxTransaction:"",
    maxDaily:""
  })
  const [maxDaily,setmaxDaily]=useState("");
  const [maxTransaction,setmaxTransaction]=useState("");
  async function getProduct(product, tab,index) {
    //product.isSelectProduct = !product.isSelectProduct;
    
    if(OpcProdSelec<0){
      setpermisosProd(permisosguardados[index]);
      setfuncionalidadHabil(3);
      await setProduct(product);
      
      if(product.maxTransaction){
        settopesxprod({
          maxTransaction:product.maxTransaction,
          maxDaily:product.maxDaily
          
        });
        /*if(topeMD==1){
          setmaxDaily(product.maxTransaction);

        }else{
          setmaxDaily(product.maxDaily);
          
        }*/

      }else{
        settopesxprod({
          maxTransaction:"",
          maxDaily:""
        });
        setmaxDaily("");

      }
      
      
      //setplacetopes("Tope Monto Transaccional");
      setOpcProdSelec(index);
    }
  }
  const terminaOpcProd=(index)=>{
    
    if(index==OpcProdSelec){
      console.log("termina edicion de opciones producto")
      product.isSelectProduct = !product.isSelectProduct;
      let copiacheck=[...checkproducto];
      copiacheck[index]=true;
      setcheckproducto([...copiacheck]);
      setOpcProdSelec(-1);
    }
  }

  const saliryguardapopOpcProd=(permisosedit)=>{
    setfuncionalidadHabil(1);
    let copiapermisos=_.cloneDeep(permisosguardados);
    copiapermisos[OpcProdSelec]=JSON.parse(JSON.stringify(permisosedit));
    setpermisosguardados(_.cloneDeep(copiapermisos));
    let copiacheck=[...checkproducto];
    copiacheck[OpcProdSelec]=true;
    setcheckproducto([...copiacheck]);
    setOpcProdSelec(-1);
    
  }
  const salirpopOpcProd=()=>{
    
    setOpcProdSelec(-1);
    setfuncionalidadHabil(1);

  }

  const handleChangeIsSelectedProduct = (event) => {
    
      setIsSelectProduct(!isSelectProduct);
      product.isSelectProduct = !product.isSelectProduct;
      
  };
  const [topeMD,settopeMD]=useState(1);
  const [placetopes,setplacetopes]=useState("Tope Diario Transaccional");
  const selectope=(eleccion)=>{
    console.log("cambiaOpcion");
    if(eleccion==1){
      setplacetopes("Tope Monto Transaccional");
      setmaxDaily(topesxprod.maxTransaction);
      settopeMD(1);
      
    }else{
      setplacetopes("Tope Diario Transaccional");
      setmaxDaily(topesxprod.maxDaily);
      settopeMD(2);
    }
  }

  //Options Productos
  const OptionsProducts=(props)=> {
    
    if (product != null && props.producto==OpcProdSelec) {
      
      setProductState(product.action);
      setProductValidation(product.validation);
      
      return (
        <>
          <div className="filaopcionescreacion mt-2 mb-2 ml-7 mr-7">
            <h2 class="mt-3"> Tipo de Acceso </h2>
            <Row className="" style={{width:"100%"}}>
              <div
                style={{width:"50%"}}
                className={classnames(
                  "radius-left mt-2 mb-2 text-center text-medium-grey cursor-pointer col h-5 p-1",
                  {
                    active: productState === "C",
                  }
                )}
                onClick={() => {
                  product.action = "C";
                  setProductState("C");
                }}
              >
                Consulta
              </div>
              <div
                style={{width:"100%"}}
                className={classnames(
                  "radius-right mt-2 mb-2 text-center text-medium-grey cursor-pointer col h-5 p-1",
                  {
                    active: productState === "T",
                  }
                )}
                onClick={() => {
                  product.action = "T";
                  setProductState("T");
                }}
              >
                Transacción
              </div>
            </Row>

          </div>
          <div className="filaopcionescreacion mt-2 mb-2 ml-7 mr-7">
            <h2 class="mt-2"> Tipo de Validación </h2>
            <Row className="" style={{width:"100%"}}>
              <div
                style={{width:"50%"}}
                className={classnames(
                  "radius-left mt-2 mb-2 text-center text-medium-grey cursor-pointer col h-5 p-1",
                  {
                    active: productValidation === "N",
                  }
                )}
                onClick={() => {
                  product.validation = "N";
                  setProductValidation("N");
                }}
              >
                OTP
              </div>
              <div
                style={{width:"50%"}}
                className={classnames(
                  "radius-right mt-2 mb-2 text-center text-medium-grey cursor-pointer col h-5 p-1",
                  {
                    active: productValidation === "S",
                  }
                )}
                onClick={() => {
                  product.validation = "S";
                  setProductValidation("S");
                }}
              >
                Supervisor
              </div>
            </Row>
          </div>
          
          
          {/*<InputGroup className="input-group-alternative mt-4 mb-4">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="fas fa-dollar-sign" />
              </InputGroupText>
            </InputGroupAddon>
            <input
              className="form-control"
              placeholder={product.maxValue || "Saldo Minimo"}
              type="text"
              ref={refMaxValue}
              onChange={handleChangeMinimum}
            />
          </InputGroup>
          <InputGroup className="input-group-alternative mt-4 mb-4">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="fas fa-dollar-sign" />
              </InputGroupText>
            </InputGroupAddon>
            <input
              className="form-control"
              placeholder={product.minValue || "Saldo Maximo"}
              type="text"
              ref={refMaxDailyValue}
              onChange={handleChangeMaximum}
            />
          </InputGroup>
          */}
         {/* <div className="filaopcionescreacion mt-2 mb-2 ml-7 mr-7">
            <Row className="" style={{width:"100%"}}>
              <div
                style={{width:"50%"}}
                className={classnames(
                  "radius-left mt-2 mb-2 text-center text-medium-grey cursor-pointer col h-7 p-2",
                  {
                    active: topeMD === 1,
                  }
                )}
                onClick={() => {
                  selectope(1)
                }}
              >
                Tope Monto Transaccional
              </div>
              <div
                style={{width:"50%"}}
                className={classnames(
                  "radius-right mt-2 mb-2 text-center text-medium-grey cursor-pointer col h-7 p-2",
                  {
                    active: topeMD === 2,
                  }
                )}
                onClick={() => {
                  selectope(2)
                }}
              >
                Tope Diario Transaccional
              </div>
            </Row>

          </div>
              */}
          
          
          <InputGroup className="input-group-alternative mt-2 mb-2 ml-7 mr-7">
            <div className="inputs-icons-borderbott">
              <input
                className="form-control h5 p-1"
                placeholder={"Tope Monto Transaccional"}
                type="text"
                ref={refMaxValue}
                onChange={handleChangeMaximunDaily}
                value={topesxprod.maxTransaction}
                style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                tabIndex = {1}
              />
              <img style={{height:"12px", }} src={IconPesos}></img>
            </div>
            </InputGroup>
          <InputGroup className="input-group-alternative mt-2 mb-2 ml-7 mr-7">    
            <div className="inputs-icons-borderbott">
              <input
                className="form-control h5 p-1 "
                placeholder="Tope Monto Diario"
                type="text"
                ref={refMaxDailyValue}
                onChange={handleChangeMaximunDaily}
                value={topesxprod.maxDaily}
                style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                tabIndex = {2}
                
                
              />
              <img style={{height:"12px", }} src={IconPesos}></img>
            </div>  
          </InputGroup>

         
          
          
          <div className="mt-2 mb-2 ml-7 mr-7" style={{display:"flex",justifyContent:"center",alignItems:"center", width:"100%"}}>
            <button style={{width:"50%"}} onClick={()=>{terminaOpcProd(props.producto)}} className="btn bg-green text-white btn-block">Guardar</button>
          </div>
          
        </>
      );
    } else{
      return(
        <div>

        </div>
      );
    }
  }
  // componente ips
  const cambiaiconoagrega=(prendido)=>{
    if(prendido){
      setestadoIconIpAgrega(IconMasRojo);
    }else{
      setestadoIconIpAgrega(IconMas);
    }
  }
  const actualizavalorip=(event)=>{
    event.preventDefault();
    setvalorIp(event.target.value);

  }
  const ComponenteIps=()=>{
    if(newUser.IsSupervisorUser=="N"){
    return(
      <div>
        {/*<p style={{margin:"0px 0px 0px 5px", textAlign:"left"}}>Podrá registrar máximo 5 Ip's. Si no registra ninguna Ip, el usuario podrá acceder a la banca virtual sin esta restricción</p>*/}
        <InputGroup className="input-group-alternative mt-2 mb-2 ml-auto mr-auto" style={{width:"80%"}}>   
          <div className="inputs-icons-borderbott">

            <input
              className="form-control p-1"
              placeholder={"Ip nueva"}
              type="text"
              /*ref={refIps}*/
              style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
              onChange={actualizavalorip}
              value={valorIp}
              autoFocus
            />
            
            <BotonEliminaIp eliminarIp={agregaIp} index={0} tipo={"agregar"}></BotonEliminaIp>
          </div>  
          <Alerts data={listAlert}></Alerts>
        </InputGroup>
        {Ips.map((item,index)=>{
          return(
            <div className="mb-xl-0 ml-auto mr-auto p-1" style={{display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"center",borderRadius:"10px",background:"#FFFFFF", margin:"10px 10px 10px 10px",width:"80%"}}>
              <h1 style={{display:"inline",fontSize:"18px"}}>{item}</h1>
              <BotonEliminaIp className="cursor-pointer" style={{width:"50%"}} eliminarIp={eliminaIp} index={index} tipo={"eliminar"}></BotonEliminaIp>
            </div>
          )
        })}
        <div style={{display:"flex",justifyContent:"center",alignItems:"center", width:"50%", margin:"15px 0px 15px 0px"}}className="ml-auto mr-auto">
          <button onClick={()=>{finEdtIps()}} className="btn-icon bg-green text-white btn btn-block">Continuar</button>
        </div>
      </div>
    );}else{
      return(
        <div>
          {/*<p style={{margin:"0px 0px 0px 5px", textAlign:"left"}}>Podrá registrar máximo 5 Ip's. Si no registra ninguna Ip, el usuario podrá acceder a la banca virtual sin esta restricción</p>*/}
          <InputGroup className="input-group-alternative mt-2 mb-2 ml-auto mr-auto" style={{width:"80%"}}>   
            <div className="inputs-icons-borderbott">
  
              <input
                className="form-control p-1"
                placeholder={"Ip nueva"}
                type="text"
                /*ref={refIps}*/
                style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                onChange={actualizavalorip}
                value={valorIp}
                autoFocus
              />
              
              <BotonEliminaIp eliminarIp={agregaIp} index={0} tipo={"agregar"}></BotonEliminaIp>
            </div>  
            <Alerts data={listAlert}></Alerts>
          </InputGroup>
          {Ips.map((item,index)=>{
            return(
              <div className="mb-xl-0 ml-auto mr-auto p-1" style={{display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"center",borderRadius:"10px",background:"#FFFFFF", margin:"10px 10px 10px 10px",width:"80%"}}>
                <h1 style={{display:"inline",fontSize:"18px"}}>{item}</h1>
                <BotonEliminaIp className="cursor-pointer" style={{width:"50%"}} eliminarIp={eliminaIp} index={index} tipo={"eliminar"}></BotonEliminaIp>
              </div>
            )
          })}
          <div style={{display:"flex",justifyContent:"center",alignItems:"center", width:"50%", margin:"15px 0px 15px 0px"}}className="ml-auto mr-auto">
          <button
                  style={{width:"50%"}}
                  onClick={pideotpcreacionusu}
                  className="bg-green text-white btn shadow btn-rounded btn-block btn-lg mt-3 mb-3 p-2 ml-auto mr-auto"
                  >
                    Crear Usuario
                </button>
          </div>
        </div>);
    }
  }
  const [Ips,setIps]=useState([]);
  const [IpAct,setIpAct]=useState("");
  const editaIp=(event)=>{
    event.preventDefault();
    setIpAct(event.target.value);
    console.log(IpAct);

  }
  const agregaIp=()=>{
    if(Ips.length<5){
      const IpValida=validaIp(valorIp)
      if(IpValida.valida){
        let listaIps=[...Ips];
        listaIps.push(IpValida.IpAjustada);
        setIps([...listaIps]);
        setIpAct("");
        setvalorIp("");
      }else{
        setListAlert([
          {
            description: "Ip invalida.Debe ser (0-255).(0-255).(0-255).(0-255) Ejemplo: 102.10.204.31",
            type: "alert alert-alert show alert-dismissible fade alert-danger",
            icon: "fas fa-exclamation-circle"
          }
        ]);
        setTimeout(()=>{deleteElementFromArr(listAlert)}, 5000);
      }
      
    }
    
  }
  const eliminaIp=(index)=>{
    if(index<Ips.length){
      let listaIps=[...Ips];
      listaIps.splice(index,1);
      setIps([...listaIps]);
    }
  }
  const finEdtIps=async()=>{
    newUser.ListIp=[...Ips];
    if(newUser.IsSupervisorUser=="N"){
      setStepLine((s) => s + 1);
      setmaxstepcreaUsu((s) => s + 1);
      const request = await axiosInstance()
        .get(
          "/WSGYG39_2/api/Inquiries/GetSupervisorUsers"
        )
        .catch((err) => {
          console.log("error en getProfile");
          console.log(err);
          return "err";
        });
      if (request != "err") {
        console.log("res getprofile");
        console.log(request.data);
        setSupervisorUsers(request.data);  
      }
    }else{
      /*
      console.log("Usuario a crear");
      console.log(newUser);
      const request = await axiosInstance()
        .post("/WSGYG39_2/api/Inquiries/CreateUser", newUser)
        .catch((err) => {
          return "err";
        });
      if (request != "err") {
        console.log("respuesta creacion de usuarios")
        console.log(request.data);
        setListProducts(request.data.productsUser);
        setUniqueIdUser(request.data.uniqueIdUser);
        setStepLine((s) => s + 2);
      }
      */
      // setStepLine((s) => s + 2);
      // setmaxstepcreaUsu((s) => s + 2);
    }
  }
  //Supervisor User
  var RelatedAccounts = createReactClass({
    render: function () {
      var data = this.props.data;
      var newsTemplate;
      var tab = this.props.tab;
      if (data.length > 0) {
        newsTemplate = data.map(function (item, index) {
          return (
            <Row key={index} onClick={() => getSupervisor(item, tab)}>
              <RelatedAccount data={item} />
            </Row>
          );
        });
      } else {
        newsTemplate = (
          <div style={{display:"flex",justifyContent:"center",alineItems:"center"}}>
            <div style={{background:"#FFFFFF",
                                          borderRadius:"10px",
                                          padding:"2rem",
                                          margin:"1rem",
                  
                                          width:"500px"}}>
              <h1>No tienes supervisores registrados</h1>
            </div>
          </div>
        );
      }
      return <div>{newsTemplate}</div>;
    },
  }
  );

  var RelatedAccount = createReactClass({
    render: function () {
      console.log("newUser1");
      console.log(newUser);
      //var ownerAccount = this.props.data.ownerAccount;
      var ownerAccount = this.props.data.name;
    if(activeSupervisor != this.props.data.code){
      return (
        <Col lg="12" xl="12" className="pt-3">
          <Card className="mb-xl-0 cursor-pointer bordeHover">
            <div className="row" style={{ padding: "1rem" }}>
              <div className="col-auto mr-3">
                <GetInitial contact={ownerAccount}></GetInitial>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span class="mb-0 text-sm">{ownerAccount}</span>
              </div>
            </div>
          </Card>
        </Col>
      );
      }else{
        return (
          <Col lg="12" xl="12" className="pt-3">
            <Card className="mb-xl-0 cursor-pointer bordeHover productoselec">
              <div className="row" style={{ padding: "1rem" }}>
                <div className="col-auto mr-3">
                  <GetInitial contact={ownerAccount}></GetInitial>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <span class="mb-0 text-sm">{ownerAccount}</span>
                </div>
              </div>
            </Card>
          </Col>
        );

      }
    },
  });

  const editanombre=(event)=>{
    event.preventDefault();
    setNombreUsuario(event.target.value);
    refName.current.focus();
  }

  const GetInitial = (props) => {
    if (props.contact !== null) {
      var initial = props.contact.substr(0, 1);
      return (
        <div class="icon icon-shape bg-green text-white rounded-circle shadow">
          {initial}
        </div>
      );
    } else return "";
  };

  async function getSupervisor(supervisor, tab) {
    console.log("Usuario a crear");
    newUser.SupervisorCode = supervisor.code;
    console.log(newUser);
    console.log("supervisor.code");
    console.log(supervisor.code);
    console.log("supervisorUsers");
    console.log(supervisorUsers);
    setSupervisorUsers(supervisorUsers);
    // if(supervisorUsers.code == supervisor.code){
    setActiveSupervisor(supervisor.code);
    //}
    /*
    const request = await axiosInstance()
      .post("/WSGYG39_2/api/Inquiries/CreateUser", newUser)
      .catch((err) => {
        return "err";
      });
    if (request != "err") {
      console.log("respuesta creacion de usuarios")
      console.log(request.data.productsUser);
      setListProducts(request.data.productsUser);
      setUniqueIdUser(request.data.uniqueIdUser);
      setStepLine((s) => s + 1);
    }
    */

    //*************Ajustado solo para IDEA *******/
    // setStepLine((s) => s + 1);
    // setmaxstepcreaUsu((s) => s + 1);
    
  }

  async function createUserProducts() {
    
    console.log("envio final creacion de usuario");
    console.log(listProducts.filter((item) => item.isSelectProduct));
    productUser.UniqueIdUser=uniqueIdUser;
    productUser.ProductsUser=listProducts.filter((item) => item.isSelectProduct);
    console.log(productUser)
    const request = await axiosInstance()
      .post(
        "/WSGYG39_2/api/Inquiries/CreateUserProducts",
        productUser
      )
      .catch((err) => {
        return "err";
      });
    if (request != "err") {//agregar mensaje de exito dependiendo respuesta 
      setResultModal(true);
      //setTabs(0);
    }
    
  }

  //Profiles
  var Profiles = createReactClass({
    render: function () {
      var data = this.props.data;
      var tab = this.props.tab;
      var newsTemplate;
      let provicional={
        id:0
      }

      if (data.length > 0) {
        return(
          <div>
            {newsTemplate = data.map(function (item, index) {
              return (
                <div className="mb-xl-0 cursor-pointer p-0" style={{display:"flex",flexDirection:"row",justifyContent:"left",alignItems:"center", margin:"10px 10px 10px 10px"}}>
                  <Checksantader mensaje={()=>{return(<p><b style={{fontWeight:"bold"}}>{item.nombrePerfil}</b>  {": " + item.descripcion}</p>)} }  estadocheck={item.habilitado} idCheck={item.id} funcionpadre={escuchaCheck}></Checksantader>
                </div>
              );
            })
            }
            <div style={{margin:"20px 10px 10px 10px",width:"50%"}}className="ml-auto mr-auto">
              <buttonnpm
                type="submit"
                className="bg-green text-white btn shadow btn-rounded btn-block"
                onClick={() => getProfile()}
              >  Continuar
              </buttonnpm>
            </div>
            
          </div>
        )
      } else {
        newsTemplate = (
          <Skeleton
            height={100}
            count={4}
            className="card-transaction-info"
            style={{ width: "-webkit-fill-available" }}
          ></Skeleton>
        );
      }
      return <div>{newsTemplate}</div>;
    },
  });

  var CardProfile = createReactClass({
    render: function () {
      var nombrePerfil = this.props.data.nombrePerfil;
      return (
        <Col lg="12" xl="12" className="pt-3">
          <Card className="mb-xl-0 shadow cursor-pointer">
            <CardBody className="">
              <Row>
                <div className="col-auto ml-4" style={{ width: "80%" }}>
                  <Row>
                    <span class="mb-0">{nombrePerfil}</span>
                  </Row>
                </div>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    },
  });

  async function getProfile() {
    console.log("guarda permisos");
    console.log(perfiles);
    let buildperfil="";
    if(perfiles.length>0){
      for(let i=0;i<perfiles.length;i++){
        if(perfiles[i].habilitado){
          buildperfil = perfiles[i].value;
        }
      }
    }
    newUser.ProfileUser = buildperfil;
    /*
    if(newUser.IsSupervisorUser=="N"){
      setStepLine((s) => s + 1);
      const request = await axiosInstance()
        .get(
          "/WSGYG39_2/api/Inquiries/GetSupervisorUsers"
        )
        .catch((err) => {
          console.log("error en getProfile");
          console.log(err);
          return "err";
        });
      if (request != "err") {
        console.log("res getprofile");
        console.log(request.data);
        setSupervisorUsers(request.data);  
      }
    }else{
      console.log("Usuario a crear");
      console.log(newUser);
      const request = await axiosInstance()
        .post("/WSGYG39_2/api/Inquiries/CreateUser", newUser)
        .catch((err) => {
          return "err";
        });
      if (request != "err") {
        console.log("respuesta creacion de usuarios")
        console.log(request.data);
        setListProducts(request.data.productsUser);
        setUniqueIdUser(request.data.uniqueIdUser);
        setStepLine((s) => s + 2);
      }
    }*/
    await setStepLine((s) => s + 1);
    setmaxstepcreaUsu((s) => s + 1);
    
  }

  //Lista Perfiles
  const ListaPerfiles = (props) => {
    if (props.listaPerfiles.length > 0) {
      return (
        <div>
          <table>
            <tr>
              <th className="col-md-2 bg-green text-white font-weight-bold h3">
                Id perfil
              </th>
              <th className="col-md-2 bg-green text-white font-weight-bold h3 ">
                Descripción
              </th>
              <th className="col-md-2 bg-green text-white font-weight-bold h3 ">
                Fecha último cambio
              </th>
              <th className="col-md-2 bg-green text-white font-weight-bold h3 ">
                Usuario último cambio
              </th>
              <th className="col-md-2 bg-green text-white font-weight-bold h3 ">
                Estado
              </th>
              <th className="col-md-2 bg-green text-white font-weight-bold h3 ">
                Detalle
              </th>
            </tr>
            {props.listaPerfiles.map((item, index) => {
              return (
                <tr key={index}>
                  <td className="col-md-1">{item.id}</td>
                  <td className="col-md-1">{item.nombrePerfil}</td>
                  <td className="col-md-1">{item.fecha}</td>
                  <td className="col-md-1">{item.ultimoUsuario}</td>
                  <td className="col-md-1">{item.habilitado}</td>
                  <td className="col-md-1">
                    <button
                      className="btn btn-green"
                      onClick={() => {
                        setTabs(5);
                        setIdperfilSelec(item.id);
                      }}
                    >
                      Detalle
                    </button>
                  </td>
                </tr>
              );
            })}
          </table>
        </div>
      );
    } else {
      return <div></div>;
    }
  };

  // Opciones del Perfil
  const PermisosProducto = (props) => {
    
    let modulo = props.modulo;
    let cabecera = [];
    let registros = [];
    /*
    if (props.listaPerfiles.length > 0) {
      for (let per = 0; per < props.listaPerfiles.length; per++) {
        if (props.listaPerfiles[per].id == props.id) {
          for (let i = 0; i < props.listaPerfiles[per].permisos.length; i++) {
            if (props.listaPerfiles[per].permisos[i].mod == modulo) {
              cabecera = props.listaPerfiles[per].permisos[i].habilidades;
              registros.push(props.listaPerfiles[per].permisos[i].registros);
            }
          }
        }
      }
    }
    console.log("Reg de opciones");

    console.log(registros);
    */
    let ff=0;
    if (cabecera.length > 0 && ff==3) {
      return (
        <div>
          <table>
            <tr>
              {cabecera.map((item) => {
                return <th className="col-md-2">{item}</th>;
              })}
            </tr>
            {registros.map((item, index) => {
              return (
                <tr>
                  {item[0].map((regi) => {
                    return <td>{regi}</td>;
                  })}
                </tr>
              );
            })}
          </table>
        </div>
      );
    } else {
      return (<div></div>);
    }
  };
  const modificaUsuario=(usuario)=>{
    setotpelimusu(false);
    console.log(usuario);
    setinfUsuModif(usuario);
    //setotpmodifusu(true);
    setTabs(8);
    dispatch(cambiaruta("Inicio/Seguridad/Administrar Usuarios/Modificar usuario"))
  }
  // Usuarios
  const cancelaUsuCM=async(tipomodf,objetoModif = {uniqueIdUser:"",
                                              emailUser:"",
                                              cellNumberUser:"",
                                              }
                                              )=>{
    if(tipomodf=="crea"){
      setIsSupervisorUser("");
      setperfiles(basePerfiles);
      setIps([]);
      setIpAct("");
      setvalorIp("");
      setTabs(4);
      setStepLine(0);
      setmaxstepcreaUsu(0);
      dispatch(cambiaruta("Inicio/Seguridad/Administrar Usuarios"));
    }else if(tipomodf=="modifica"){
      dispatch(cambiaruta("Inicio/Seguridad/Administrar Usuarios"));
      setTabs(4);
      getUsers();
      setStepLineM(0);
      if(objetoModif.uniqueIdUser.length>0){
        let copialistaUsu=_.cloneDeep(InfUsu);
        for(let i=0;i<copialistaUsu.length;i++){
          if(copialistaUsu[i].uniqueIdUser==objetoModif.uniqueIdUser){
            copialistaUsu[i].emailUser=objetoModif.emailUser;
            copialistaUsu[i].cellNumberUser=objetoModif.cellNumberUser;
            i=copialistaUsu.length;
          }
        }
        setInfUsu(_.cloneDeep(copialistaUsu));
      } 
    }else{
      if(objetoModif.uniqueIdUser=="modificadomi"){
        await getConsulta();
        setnotificadomi(true);
        setmensajenotifdomi("La modificación de la asociación fue exitosa");
      }
      if(objetoModif.uniqueIdUser=="creacion"){
        await getConsulta();
        setnotificadomi(true);
        setmensajenotifdomi("La creación de la asociación fue exitosa");
      }
      
      //setTabs(9);
      dispatch(cambiaruta("Inicio/Seguridad"));
    }
    
  }
  const eliminaUsuario=async(usuario)=>{
    console.log(usuario);
    setinfUsuElim({uniqueIdUser:usuario.uniqueIdUser});
    setotpelimusu(true);
    /*
    const request = await axiosInstance().delete("/WSGYG39_2/api/Inquiries/DeleteUser/" + usuario.uniqueIdUser)
      .catch((err) => {
        return "err";
      });
    if (request != "err") {//agregar mensaje de exito dependiendo respuesta 
      console.log(request);
    }
    */
   let bodyotp={
    UniqueIdUser:usuario.uniqueIdUser
   }
    console.log("uniqueIdUser: " + bodyotp.UniqueIdUser);
    const request = await axiosInstance().post("/WSGYG39_2/api/Inquiries/GenerateOTP",bodyotp)
      .catch((err) => {
        console.log(err);
        return "err";
      });
    if (request != "err") {//agregar mensaje de exito dependiendo respuesta 
      console.log(request);
      setidtransfer(request.data.idTransfer);
      setcargandootpelimusu(false);
    }
  }
  

  const ListUsuarios = () => {
    let usuFil=[];
    if (InfUsu.length > 0){
      for(let i=0;i<InfUsu.length;i++){
        if(InfUsu[i].statusUser!="PENDIENTE POR AUTORIZAR"){
          usuFil.push(JSON.parse(JSON.stringify(InfUsu[i])));
        }
      }
    }
    console.log("lista de usuarios");
    console.log(usuFil)

    if (usuFil.length > 0) {
      return (
        <table className="mb-4">
          <tr>
            <th className="col-md-2 bg-grissantander text-white text-center font-weight-bold h4 p-1">
              Id usuario
            </th>
            <th className="col-md-2 bg-grissantander text-white text-center font-weight-bold h4 p-1">
              Estado
            </th>
            <th className="col-md-2 bg-grissantander text-white text-center font-weight-bold h4 ">
              Correo electrónico
            </th>
            <th className="col-md-2 bg-grissantander text-white text-center font-weight-bold h4 ">
              Número celular
            </th>
            
            <th className="col-md-2 bg-grissantander text-white text-center font-weight-bold h4 p-1">Acciones</th>
            {/*<th className="col-md-2 bg-green text-white font-weight-bold h3 ">
              Hora ultimo ingreso
            </th>
            <th className="col-md-2 bg-green text-white font-weight-bold h3 ">
              Fecha ultimo ingreso
            </th>*/}
          </tr>

          {usuFil.map((item,index) => {
            if(item.statusUser=="ELIMINADO"){
              return (
                <tr>
                  <td className="col-md-1 text-center bg-white p-1" style={{fontSize:"12px"}}>{item.nidUser}</td>
                  <td className="col-md-1 text-center bg-white p-1" style={{fontSize:"12px"}}>{item.statusUser}</td>
                  <td className="col-md-1 text-center bg-white p-1" style={{fontSize:"12px"}}>{item.emailUser}</td>
                  <td className="col-md-1 text-center bg-white p-1" style={{fontSize:"12px"}}>{item.cellNumberUser}</td>
                  <td className="col-md-1 text-center bg-white p-1">
                    <div style={{display:"flex", flexDirection:"row"}}>
                      
                    </div>
                  </td>
                  {/*<td className="col-md-1">{item.FechaUltIng}</td>*/}
                </tr>
              );
            }else if(item.statusUser=="BLOQUEADO"){
              return (
                <tr>
                  <td className="col-md-1 text-center bg-white p-1" style={{fontSize:"12px"}}>{item.nidUser}</td>
                  <td className="col-md-1 text-center bg-white p-1" style={{fontSize:"12px"}}>{item.statusUser}</td>
                  <td className="col-md-1 text-center bg-white p-1" style={{fontSize:"12px"}}>{item.emailUser}</td>
                  <td className="col-md-1 text-center bg-white p-1" style={{fontSize:"12px"}}>{item.cellNumberUser}</td>
                  <td className="col-md-1 text-center bg-white p-1" >
                    <div style={{display:"flex", flexDirection:"row"}}>
                      
                      <button className="btn-icon bg-white text-green btn" onClick={()=>{pideconfirmdesblocousu(item.nameUser,item.tidUser,item.nidUser,item.uniqueIdUser)}} style={{fontSize:"10px",height:"25px", padding:"4px 4px 4px 4px"}}>Desbloquear</button>
                      
                    </div>
                  </td>
                  {/*<td className="col-md-1">{item.FechaUltIng}</td>*/}
                </tr>
              );
            }else{
              return (
                <tr>
                  <td className="col-md-1 text-center bg-white p-1" style={{fontSize:"12px"}}>{item.nidUser}</td>
                  <td className="col-md-1 text-center bg-white p-1" style={{fontSize:"12px"}}>{item.statusUser}</td>
                  <td className="col-md-1 text-center bg-white p-1" style={{fontSize:"12px"}}>{item.emailUser}</td>
                  <td className="col-md-1 text-center bg-white p-1" style={{fontSize:"12px"}}>{item.cellNumberUser}</td>
                  <td className="col-md-1 text-center bg-white p-1" >
                    <div style={{display:"flex", flexDirection:"row"}}>
                      <button className="btn-icon bg-white text-green btn" onClick={()=>{modificaUsuario(item)}} style={{fontSize:"10px",height:"25px", padding:"4px 4px 4px 4px"}}>Modificar</button>
                      <button className="btn-icon bg-white text-green btn" onClick={()=>{pideconfirmbloqueousu(item.nameUser,item.tidUser,item.nidUser,item.uniqueIdUser)}} style={{fontSize:"10px",height:"25px", padding:"4px 4px 4px 4px"}}>Bloquear</button>
                      <button className="btn-icon bg-white text-green btn" onClick={()=>{eliminaUsuario(item)}} style={{fontSize:"10px",height:"25px", padding:"4px 4px 4px 4px"}}>Eliminar</button>
                    </div>
                  </td>
                  {/*<td className="col-md-1">{item.FechaUltIng}</td>*/}
                </tr>
              );
            }
          })}
        </table>
      );
    } else {
      return <div></div>;
    }
  };
 
  // handle
  const handleSubmit = async(e) => {
    e.preventDefault();
    //let nidvalido=caracterespecial(refNid.current.value);
    //if(nidvalido==false){
      newUser.NidUser = refNid.current.value;
      newUser.NameUser = refName.current.value;
      newUser.EmailUser = refEmail.current.value;
      newUser.CellNumberUser = refCellNumber.current.value;
      newUser.TidUser = typesDocument;
      newUser.IsSupervisorUser = isSupervisorUser;
      console.log(newUser);
      setStepLine((s) => s + 1);
      setmaxstepcreaUsu((s) => s + 1);
     
      
      
   /* }else{
      let copialista=listAlert;
      await setListAlert([
        {
          description: "La identificacion no puede contener caracteres especiales.",
          type: "alert alert-alert show alert-dismissible fade alert-danger",
          icon: "fas fa-exclamation-circle"
        }
      ]);
      copialista.push(
        {
          description: "La identificacion no puede contener caracteres especiales.",
          type: "alert alert-alert show alert-dismissible fade alert-danger",
          icon: "fas fa-exclamation-circle"
        }
      )
      setTimeout(()=>{deleteElementFromArr(copialista)}, 2000);
    }
    */
  };

  const handleChangeAgency = (event) => {
    newUser.AgencyUser = event.target.value;
  };
  async function getConsulta() {
    setIsLoading(true);
    const request = await axiosInstance().get("/WSGYG39_2/api/Domiciliation/Domiciliations")
      .catch(err => {
        setIsLoading(false)
        return 'err';
      });
    if (request != 'err') {
      setIsLoading(false);
      console.log(request.data);
      // console.log(request.data.summaryProduct.product);
      setConsultaDomiciliacion(request.data);
    }
    
    return request;
  }
  class NavsTransfer extends React.Component {
    toggleNavs = (e, state, index) => {
      e.preventDefault();
      if(index == 4){
        setActiveUsu(true)
        setActiveDomi(false)
        setActiveTrans(false)
        setImagen(icon_Administras_usuariosA)
        setColor("text-green")
        setColorDomi("text-gray-dark")
        setImagenDomiciliacion(Transferencias)
        setImagenTrans(icon_Administras_usuarios)
        setColorTrans("text-gray-dark")

      }else if(index == 9){
        getConsulta();
        setActiveDomi(true)
        setActiveUsu(false)
        setActiveTrans(false)
        setImagenDomiciliacion(TransferenciasA)
        setColorDomi("text-green")
        setColorTrans("text-gray-dark")
        setColor("text-gray-dark")
        setImagen(icon_Administras_usuarios)
        setImagenTrans(icon_Administras_usuarios)

      }else if(index == 7){
        setActiveTrans(true)
        setActiveUsu(false)
        setActiveDomi(false)
        setImagenTrans(icon_Administras_usuariosA)
        setColorTrans("text-green");
        setColorDomi("text-gray-dark")
        setImagenDomiciliacion(Transferencias)
        setImagen(icon_Administras_usuarios)
        setColor("text-gray-dark")
      }else{
        setActiveUsu(false)
        setActiveDomi(false)
        setActiveTrans(false)
        dispatch(cambiaruta("Inicio/Seguridad"))
        setImagenTrans(icon_Administras_usuarios)
        setColorTrans("text-gray-dark");
        setColorDomi("text-gray-dark")
        setImagenDomiciliacion(Transferencias)
        setImagen(icon_Administras_usuarios)
        setColor("text-gray-dark")
      }
      //setotpelimusu(false);
      setTabs(index);
      
    };
    
    render() {
      switch (funcionalidadHabil) {
        case 0:
            return (
              <div>

              </div>
            )
          
          break;
        case 1:
          return (
            <>
              <div className="header pb-4 pt-5 pt-md-8">
                <Container fluid>
                  <div className="header-body">
                    <Nav
                      className="justify-content-center flex-column flex-md-row"
                      id="tabs-icons-text"
                      pills
                      role="tablist"
                    >
                      {/*
                      <NavItem>
                        <NavLink
                          aria-selected={tabs === 1}
                          className={classnames(
                            "card-body ml-2 mb-2 mb-xl-0 shadow",
                            {
                              active: tabs === 1,
                            }
                          )}
                          onClick={(e) => this.toggleNavs(e, "tabs", 1)}
                          href=""
                          role="tab"
                        >
                          <Row className="justify-content-center m-2">
                            <div className="icon icon-shape">
                              <img
                                className="my-header-image mt-5"
                                src={
                                  require("../../assets/img/illustrations/Icono-Cambiar-Contraseña-Rojo.png")
                                    .default
                                }
                              />
                            </div>
                          </Row>
                          <Row className="justify-content-center m-2">
                            <p
                              className="mt-3 mb-0 text-bold text-green"
                              style={{
                                fontSize: 13 + "px",
                                width: 101 + "px",
                                textAlign: "center",
                                lineHeight: 1.43,
                              }}
                            >
                              Cambiar Contraseña
                            </p>
                          </Row>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          aria-selected={tabs === 2}
                          className={classnames(
                            "card-body ml-2 mb-2 mb-xl-0 shadow",
                            {
                              active: tabs === 2,
                            }
                          )}
                          onClick={(e) => this.toggleNavs(e, "tabs", 2)}
                          href=""
                          role="tab"
                        >
                          <Row className="justify-content-center m-2">
                            <div className="icon icon-shape">
                              <img
                                className="my-header-image mt-5"
                                src={
                                  require("../../assets/img/illustrations/Icono-Actualizar-Datos-Usuario-Rojo.png")
                                    .default
                                }
                              />
                            </div>
                          </Row>
                          <Row className="justify-content-center m-2 text-green">
                            <p
                              className="mt-3 mb-0 text-bold"
                              style={{
                                fontSize: 13 + "px",
                                width: 101 + "px",
                                textAlign: "center",
                                lineHeight: 1.43,
                              }}
                            >
                              Actualizar Datos del Usuario
                            </p>
                          </Row>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          aria-selected={tabs === 3}
                          className={classnames(
                            "card-body ml-2 mb-2 mb-xl-0 shadow",
                            {
                              active: tabs === 3,
                            }
                          )}
                          onClick={(e) => this.toggleNavs(e, "tabs", 3)}
                          href=""
                          role="tab"
                        >
                          <Row className="justify-content-center m-2">
                            <div className="icon icon-shape">
                              <img
                                className="my-header-image mt-5"
                                src={
                                  require("../../assets/img/illustrations/Icono-Administrar-Perfiles-Rojo.png")
                                    .default
                                }
                              />
                            </div>
                          </Row>
                          <Row className="justify-content-center m-2 text-green">
                            <p
                              className="mt-3 mb-0 text-bold"
                              style={{
                                fontSize: 13 + "px",
                                width: 101 + "px",
                                textAlign: "center",
                                lineHeight: 1.43,
                              }}
                            >
                              Administrar Perfiles
                            </p>
                          </Row>
                        </NavLink>
                      </NavItem>
                            */}
                      <NavItem>
                        <NavLink
                          style={{"padding-top":0 +"rem",width:110 +'px',height:95 +'px'}}
                          aria-selected={tabs === 4}
                          className={classnames(
                            "card-body ml-1 mb-0 pb-0 mb-xl-0 shadow h-100",
                            {
                              active:activeUsu,
                            }
                          )}
                          onClick={(e) => {this.toggleNavs(e, "tabs", 4)
                              dispatch(cambiaruta("Inicio/Seguridad/Administrar Usuarios"))}}
                          href=""
                          role="tab"
                          
                        >
                          <Row className="justify-content-center " style={{"padding":0.5 +"rem","height":"45%"}}>
                            <div className="icon icon-shape mt-0 mb-0 pb-0" style={{"padding":0 +"rem"}}>
                              <img
                                className="my-header-image mt-1 mb-1 pt-0"
                                src={imagen}
                              />
                            </div>
                          </Row>
                          <Row className={classnames ("justify-content-center mt-0 pb-0",
                            color
                          )}>
                            <p
                              className="mt-1 mb-0 pt-0 text-bold"
                              style={{
                                fontSize: 14 + "px",
                                width: 105 + "px",
                                textAlign: "center",
                                "line-height":1.25 +'em',
                                marginTop:2 +"px"
                              }}
                            >
                              Administrar Usuarios
                            </p>
                          </Row>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        {/* <NavLink
                          style={{"padding-top":0 +"rem",width:110 +'px',height:95 +'px'}}
                          aria-selected={tabs === 9}
                          className={classnames(
                            "card-body ml-1 mb-0 pb-0 mb-xl-0 shadow h-100",
                            {
                              active:activeDomi,
                            }
                          )}
                          onClick={(e) => {this.toggleNavs(e, "tabs", 9)
                              dispatch(cambiaruta("Inicio/Seguridad/Domiciliación"))}}
                          href=""
                          role="tab"
                        >
                          <Row className="justify-content-center " style={{"padding":0.5 +"rem","height":"45%"}}>
                            <div className="icon icon-shape mt-0 mb-0 pb-0" style={{"padding":0 +"rem"}}>
                              <img
                                className="my-header-image mt-1 mb-1 pt-0"
                                src={imagenDomiciliacion}
                              />
                            </div>
                          </Row>
                          <Row className={classnames ("justify-content-center mt-0 pb-0",
                            colorDomi
                          )}>
                            <p
                              className="mt-3 mb-0 pt-0 text-bold"
                              style={{
                                fontSize: 14 + "px",
                                width: 105 + "px",
                                textAlign: "center",
                                "line-height":1.25 +'em',
                                marginTop:2 + "px"
                              }}
                            >
                              Domiciliación
                            </p>
                          </Row>
                        </NavLink> */}
                      </NavItem>
                      
                      <NavItem>
                        {/* <NavLink
                          style={{"padding-top":0 +"rem",width:110 +'px',height:105 +'px'}}
                          aria-selected={tabs === 7}
                          className={classnames(
                            "card-body ml-2 mb-2 mb-xl-0 shadow",
                            {
                              active:activeTrans,
                            }
                          )}
                          onClick={(e) =>{ this.toggleNavs(e, "tabs", 7)
                              dispatch(cambiaruta("Inicio/Seguridad/Transacciones pendientes"))}}
                          href=""
                          role="tab"
                        >
                          <Row className="justify-content-center" style={{"padding":0.5 +"rem","height":"45%"}}>
                            <div className="icon icon-shape mt-0 mb-0 pb-0" style={{"padding":0 +"rem"}}>
                              <img
                                className="my-header-image mt-1 mb-1 pt-0"
                                src={imagenTrans}
                              />
                            </div>
                          </Row>
                          <Row className={classnames ("justify-content-center mt-0 pb-0",
                            colorTrans
                          )}>
                            <p
                              className="mt-2 mb-0 pt-0 text-bold"
                              style={{
                                fontSize: 14 + "px",
                                width: 105 + "px",
                                textAlign: "center",
                                lineHeight: 1.25 + "em",
                                marginTop:2 + "px"
                              }}
                            >
                              Transacciones pendientes
                            </p>
                          </Row>
                        </NavLink> */}
                      </NavItem>
                          
                    </Nav>
                  </div>
                </Container>
              </div>
              <Container className="pb-5">
                <TabContent activeTab={"tabs" + tabs}>
                  <TabPane tabId="tabs1"></TabPane>
                  <TabPane tabId="tabs2"></TabPane>
                  <TabPane tabId="tabs3">
                    <ListaPerfiles listaPerfiles={perfiles}></ListaPerfiles>
                  </TabPane>
                  <TabPane tabId="tabs4">
                    {console.log("otpelimusu"+ otpelimusu)}
                    <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"75%"}}className="ml-auto mr-auto">
                      <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"30%"}}>
                       
                        <button
                          style={{"margin-bottom":"24px"}}
                          className="bg-green text-white btn btn-rounded btn-block"
                          onClick={()=>{iniciocreaUsu()
                          dispatch(cambiaruta("Inicio/Seguridad/Administrar Usuarios/Agregar Usuario"))}}
                        >
                        
                          <img src={
                            require("../../assets/img/icons/Icono-Inscribir-Contacto-Blanco.png")
                              .default
                          }/>&nbsp;
                          Agregar Usuario
                        </button>
                        
                      </div>
                    </div>
                    
                    <ListUsuarios></ListUsuarios>
                    <Alerts data={listAlert}></Alerts>
                    
                  </TabPane>
                  <TabPane tabId="tabs7">
                    <CompTransPen ></CompTransPen>
                    <Compotp esperando={loadOtpAuthorize} pideotp={otpAuthorize} funcrespadre={responseotpAuthorize} mensaje={"Digita la clave temporal que se te envio para autorizar la transacción"}></Compotp>
                    <Alerts data={listAlert}></Alerts>
                    <Confirmmodal esperando={false} pideconfirm={confirmDecline} funcrespadre={declineTransaccion} mensaje="Confirma si deseas rechazar la transacción"></Confirmmodal>
                    <Modal
                      className="modal-dialog-centered"
                      contentClassName=""
                      isOpen={otpProcessModal}
                      toggle={() => setotpProcessModal(!otpProcessModal)}
                    >
                      <div className="p-4">
                      <div onClick={ejecutasalirOtpProcessModal} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                    <h1 style={{margin:"-15px -10px 0px 0px",fontSize:"20px"}}>
                                        <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                          <img
                                            className=""
                                            src={
                                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                                            }/>
                                            </span></h1>
                                </div>
                        <div class="my-modal-header" >
                          <img alt="delete-icon" class="my-header-brand-img" src={require("../../assets/img/brand/santander.png").default} />
                          <img style={{height:"100px", width:"100px"}} alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/success-transfer.svg").default} />
                          <div class="header-title">
                          <h5 class="avv-title-bold" style={{fontSize:"20px"}}>Tu transferencia fue {authorizationStatus}.</h5>
                            {/* <h5 class="avv-title-bold">Tu transferencia a la cuenta {productTwo.numeroCuenta} {productTwo.accountNumber} fue aprobada.</h5>
                            <ul className style={{ listStyle: "none", padding: 0 + 'px', margin: 5 + 'px' }}>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Valor</p>
                                <p style={{ textAlign: "right", margin: 0 }}><NumberFormat value={value} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Costo</p>
                                <p style={{ textAlign: "right", margin: 0 }}><NumberFormat value={commission} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Hacia</p>
                                <div style={{ textAlign: "right", margin: 0 }}>
                                  <p style={{ margin: 0 }}>{productTwo.ownerAccount}</p>
                                  <p style={{ margin: 0 }}>Santander</p>
                                  <p style={{ margin: 0 }}> Ahorros No. {productTwo.numeroCuenta} {productTwo.accountNumber}</p>
                                </div>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Desde</p>
                                <div style={{ textAlign: "right", margin: 0 }}>
                                  <p style={{ margin: 0 }}>Ahorros No. {productOne.accountNumber}</p>
                                  <p style={{ margin: 0 }}>Disponible <NumberFormat value={productOne.balance} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                                </div>
                              </li>
                            </ul> */}
                          </div>
                        </div>
                        {/* <div class="m-2">
                          <button style={{width:"50%"}}class="my-btn btn bg-green text-white shadow btn-block ml-auto mr-auto" type="button" onClick={() => { setProcessModal(false); setTabs(0) }}> Continuar </button>
                          <Pdf targetRef={ref} filename="comprobante.pdf">
                            {({ toPdf }) => (
                              <button class="btn bg-gradient-white text-gray shadow btn-block btn-icon" type="button" onClick={toPdf}>
                                <span class="btn-inner--icon">
                                  <i class="fas fa-download"></i>
                                </span>
                                <span class="btn-inner--text">Descargar comprobante</span>
                              </button>
                            )}
                          </Pdf>

                        </div> */}
                      </div>
                    </Modal>
                  </TabPane>
                  <TabPane tabId="tabs5">
                    <Container fluid key="container-tab">
                      <Row key="row-step2">
                        <Col xl="12" lg="12">
                          <DivStepper
                            step={step}
                            listStep={listStep}
                            tab={5}
                            type={"tab"}
                          >
                            <DivStep>
                              <div className="text-center m-4">
                                <h2 class="ml-2"> Productos de Crédito </h2>
                              </div>
                              <PermisosProducto
                                listaPerfiles={perfiles}
                                modulo="Productos de credito"
                                id={idperfilSelec}
                              ></PermisosProducto>
                            </DivStep>
                            <DivStep>
                              <div className="text-center m-4">
                                <h2 class="ml-2"> Productos de Ahorro </h2>
                                <PermisosProducto
                                  listaPerfiles={perfiles}
                                  modulo="Productos de ahorro"
                                  id={idperfilSelec}
                                ></PermisosProducto>
                              </div>
                            </DivStep>
                            <DivStep>
                              <div className="text-center m-4">
                                <h2 class="ml-2"> Depósitos a Término </h2>
                                <PermisosProducto
                                  listaPerfiles={perfiles}
                                  modulo="Deposito a termino"
                                  id={idperfilSelec}
                                ></PermisosProducto>
                              </div>
                            </DivStep>
                            <DivStep>
                              <div className="text-center m-4">
                                <h2 class="ml-2"> Opciones Generales </h2>
                                <PermisosProducto
                                  listaPerfiles={perfiles}
                                  modulo="Opciones generales"
                                  id={idperfilSelec}
                                ></PermisosProducto>
                              </div>
                            </DivStep>
                          </DivStepper>
                        </Col>
                      </Row>
                    </Container>
                  </TabPane>
                  <TabPane tabId="tabs6">
                    <Container fluid>
                      <Row>
                        <Col xl="3" lg="2"></Col>
                        <Col xl="6" lg="8">
                          <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
                            <button className="btn-icon bg-white text-green btn" onClick={()=>{cancelaUsuCM("crea")}}>Cancelar</button>
                          </div>
                          <DivStepper
                            step={stepLine}
                            listStep={listStepLine}
                            tab={6}
                            type={"line"}
                          >
                            <DivStep>
                              {/*
                              <Row className="m-lg-1 m-xs-0 m-md-0" style={{height:"48px"}}>
                                <div
                                  className={classnames(
                                    "radius-left shadow p-3  text-center text-medium-grey cursor-pointer col h6",
                                    {
                                      active: typesDocument === "1",
                                    }
                                  )}
                                  onClick={() => getTypeDocument("1")}
                                >
                                  CC
                                </div>
                                <div
                                  className={classnames(
                                    "radius-middle shadow p-3  text-center text-medium-grey cursor-pointer col h6",
                                    {
                                      active: typesDocument === "2",
                                    }
                                  )}
                                  onClick={() => getTypeDocument("2")}
                                >
                                  CE
                                </div>
                                <div
                                  className={classnames(
                                    "radius-middle shadow p-3  text-center text-medium-grey cursor-pointer col h6",
                                    {
                                      active: typesDocument === "3",
                                    }
                                  )}
                                  onClick={() => getTypeDocument("3")}
                                >
                                  NIT
                                </div>
                                <div
                                  className={classnames(
                                    "radius-middle shadow p-3  text-center text-medium-grey cursor-pointer col h6",
                                    {
                                      active: typesDocument === "4",
                                    }
                                  )}
                                  onClick={() => getTypeDocument("4")}
                                >
                                  TI
                                </div>
                                <div
                                  className={classnames(
                                    "radius-middle shadow p-3  text-center text-medium-grey cursor-pointer col h6",
                                    {
                                      active: typesDocument === "5",
                                    }
                                  )}
                                  onClick={() => getTypeDocument("5")}
                                >
                                  PS
                                </div>
                                <div
                                  className={classnames(
                                    "radius-middle shadow p-3  text-center text-medium-grey cursor-pointer col h6",
                                    {
                                      active: typesDocument === "6",
                                    }
                                  )}
                                  onClick={() => getTypeDocument("6")}
                                >
                                  CD
                                </div>
                                <div
                                  className={classnames(
                                    "radius-middle shadow p-3  text-center text-medium-grey cursor-pointer col h6",
                                    {
                                      active: typesDocument === "7",
                                    }
                                  )}
                                  onClick={() => getTypeDocument("7")}
                                >
                                  SE
                                </div>
                                <div
                                  className={classnames(
                                    "radius-middle shadow p-3  text-center text-medium-grey cursor-pointer col h6",
                                    {
                                      active: typesDocument === "8",
                                    }
                                  )}
                                  onClick={() => getTypeDocument("8")}
                                >
                                  FI
                                </div>
                                <div
                                  className={classnames(
                                    "radius-right shadow p-3  text-center text-medium-grey cursor-pointer col h6",
                                    {
                                      active: typesDocument === "9",
                                    }
                                  )}
                                  onClick={() => getTypeDocument("9")}
                                >
                                  RCN
                                </div>
                              </Row>
                                  */}
                              <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%"}}>
                                <p style={{fontSize:"16px"}}>{descripLineaCreacion[0]}</p>
                              </div>
                             
                              <Modal
                                  className="modal-dialog-centered"
                                  contentClassName=""
                                  isOpen={infoModalSupervisor}
                                  toggle={() => setInfoModalSupervisor(!infoModalSupervisor)}
                              >
                  
                                <div className="p-4">
                                <div onClick={ejecutasalir} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                    <h1 style={{margin:"-15px -10px 0px 0px",fontSize:"20px"}}>
                                        <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                          <img
                                            className=""
                                            src={
                                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                                            }/>
                                            </span></h1>
                                </div>
                                  <div class="my-modal-header">
                                    <img alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/Cancel.png").default} />
                                    <div class="header-title">
                                      <h5 class="avv-title-bold">Información sobre creación de usuario</h5>
                                      <p class="header-subtitle">Puedes elegir si el usuario a crear tendrá la función de supervisar a otros usuarios para aprobar o rechazar transacciones pendientes.</p>
                                    </div>
                                    {/* <div className="mt-4">
                                      <Link class="btn-icon text-green btn" href="/Formato de Transacciones Masivas.xlsm">
                                        <span class="btn-inner--icon">
                                          <i class="far fa-question-circle"></i>
                                        </span>
                                        <span class="btn-inner--text">Ayuda</span>
                                      </Link>
                                    </div> */}
                                  </div>
                                </div>
                              </Modal>
                            <form onSubmit={handleSubmit}>
                              <Row className="m-lg-1 m-xs-0 m-md-0" style={{height:"65px"}}>
                                <div
                                  className={classnames(
                                    "radius-left p-3 mt-2 mb-2 text-center text-medium-grey cursor-pointer col h5",
                                    {
                                      active: isSupervisorUser === "S",
                                    }
                                  )}
                                  onClick={() =>{ getIsSupervisor("S");setCheckSupervisor(true)}}
                                >
                                  Supervisor
                                </div>
                                <div
                                  className={classnames(
                                    "radius-right p-3 mt-2 mb-2 text-center text-medium-grey cursor-pointer col h5",
                                    {
                                      active: isSupervisorUser === "N",
                                    }
                                  )}
                                  onClick={() =>{ getIsSupervisor("N");setCheckSupervisor(true)}}
                                >
                                  No Supervisor
                                </div>
                              
                                <button class="btn-icon text-green btn" onClick={() => setInfoModalSupervisor(true)}>
                                  <span class="btn-inner--icon">
                                    <i class="far fa-question-circle"></i>
                                  </span>
                              </button>
                              </Row>
                               
                                <InputGroup className="input-group-alternative mt-2 mb-3">
                                  <div className="inputs-icons-borderbott">
                                    <select
                                      disabled={!(checkSupervisor)}
                                      onChange={getTypeDocument}
                                      placeholder="Selecciona el tipo de documento"
                                      style={{border:"none",width:"100%",fontSize:"14px",height:"33px"}}
                                    >
                                      <option value="1" selected={tidelec[0]}>Cédula de Ciudadanía</option>
                                      <option value="2" selected={tidelec[1]}>Tarjeta de Identidad</option>
                                      <option value="3" selected={tidelec[2]}>NIT</option>
                                      <option value="5" selected={tidelec[3]}>Pasaporte</option>
                                      <option value="6" selected={tidelec[4]}>Carnet Diplomático</option>
                                      <option value="8" selected={tidelec[5]}>Fideicomiso</option>
                                      <option value="9" selected={tidelec[6]}>Registro Civil de Nacimiento</option>
                                    </select>
                                    <img style={{height:"12px", }} src={IconTid}></img>
                                  </div>
                                </InputGroup>
                                <InputGroup className="input-group-alternative mt-2 mb-3">
                                    <div className="inputs-icons-borderbott">
                                      <input
                                        maxLength={17}
                                        required
                                        pattern = "[A-Za-z0-9]+"
                                        onInvalid={e => e.target.setCustomValidity('Ingrese un número de identificación válido')}
                                        onInput={e => e.target.setCustomValidity('')}
                                        className="form-control h5 p-1"
                                        placeholder="Documento de Identidad"
                                        type="text"
                                        disabled={!(checkSupervisor)}
                                        ref={refNid}                            
                                        style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                                      />
                                      <img style={{height:"12px", }} src={IconNid}></img>
                                    </div>
                                    <Alerts data={listAlert}></Alerts>
                                </InputGroup>
                                <InputGroup className="input-group-alternative mt-3 mb-3">
                                    <div className="inputs-icons-borderbott">
                                      <input
                                        required
                                        pattern="[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]+"
                                        className="form-control h5 p-1"
                                        placeholder="Nombre del cliente"
                                        type="text"
                                        
                                        disabled={!(checkSupervisor)}
                                        ref={refName}
                                        style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                                      />
                                      <img style={{height:"12px", }} src={IconNom}></img>
                                    </div>
                                </InputGroup>
                                <InputGroup className="input-group-alternative  mt-3 mb-3">
                                    <div className="inputs-icons-borderbott">
                                      <input
                                        maxLength={50}
                                        required
                                        pattern= '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[.]{1}[a-zA-Z]{2,}$'
                                        className="form-control h5 p-1"
                                        placeholder="Correo electrónico"
                                        onInvalid={e => e.target.setCustomValidity('Ingrese un correo válido')}
                                        onInput={e => e.target.setCustomValidity('')}
                                        type="text"
                                        disabled={!(checkSupervisor)}
                                        ref={refEmail}
                                        style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                                      />
                                      <img style={{height:"12px", }} src={IconCorreo}></img>
                                    </div>
                                </InputGroup>
                                <InputGroup className="input-group-alternative  mt-3 mb-3">
                                    <div className="inputs-icons-borderbott">
                                      <input
                                        required
                                        maxLength={10}
                                        pattern = "[A-Za-z0-9]+"
                                        className="form-control h5 p-1"
                                        placeholder="Número de celular"
                                        type="text"
                                        disabled={!(checkSupervisor)}
                                        ref={refCellNumber}
                                        style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                                      />
                                      <img style={{height:"12px", }} src={IconCel}></img>
                                    </div>
                                </InputGroup>
                              
                                <button
                                  type="submit"
                                  className="bg-green text-white btn shadow btn-rounded btn-block mb-3 ml-auto mr-auto"
                                  style={{width:"50%"}}
                                  disabled={!(checkSupervisor)}
                                >
                                  Continuar
                                </button>
                              </form>
                              <Alerts data={listAlert}></Alerts>
                            </DivStep>
                            <DivStep>
                              <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%"}}>
                                <p>{descripLineaCreacion[1]}</p>
                              </div>
                              <Profiles data={perfiles} tab={6}></Profiles>
                            </DivStep>
                            
                            <DivStep>
                              <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%"}}>
                                <p>{descripLineaCreacion[2]}</p>
                              </div>
                              <ComponenteIps></ComponenteIps>
                              {/* <button
                                style={{width:"50%"}}
                                onClick={pideotpcreacionusu}
                                className="bg-green text-white btn shadow btn-rounded btn-block btn-lg mt-3 mb-3 p-2 ml-auto mr-auto"
                              >
                                Crear Usuario
                              </button> */}
                            </DivStep>
                            <DivStep>
                              <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%"}}>
                                <p>{descripLineaCreacion[3]}</p>
                              </div>
                              <RelatedAccounts
                                data={supervisorUsers}
                                tab={6}
                              ></RelatedAccounts>
                              <button
                                style={{width:"50%"}}
                                onClick={pideotpcreacionusu}
                                className="bg-green text-white btn shadow btn-rounded btn-block btn-lg mt-3 mb-3 p-2 ml-auto mr-auto"
                              >
                                Crear Usuario
                              </button>
                              <Alerts data={listAlert}></Alerts>
                            </DivStep>
                            {/* <DivStep>
                              <Products data={listProducts} tab={6}></Products>
                              <button
                                style={{width:"50%"}}
                                onClick={pideotpcreacionusu}
                                className="bg-green text-white btn shadow btn-rounded btn-block btn-lg mt-3 mb-3 p-2 ml-auto mr-auto"
                              >
                                Crear Usuario
                              </button>
                              <Alerts data={listAlert}></Alerts>
                            </DivStep> */}
                          </DivStepper>
                        </Col>
                        <Col xl="3" lg="2"></Col>
                      </Row>
                    </Container>
                  </TabPane>
                  <TabPane tabId="tabs8">
                    <Container fluid>
                      <Row style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                        <ComponentemodificaUsu infUsuM={infUsuModif} cancelaMU={cancelaUsuCM}></ComponentemodificaUsu>
                      </Row>
                    </Container>
                  </TabPane>
                  <TabPane tabId="tabs9">
                    <Container fluid>
                      <Row style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                        {/* <Domiciliacion canceladomi={cancelaUsuCM}></Domiciliacion> */}
                        <Modal
                            className="modal-dialog-centered"
                            contentClassName="bg-transparent shadow-none"
                            isOpen={isLoading}
                          >
             
                          <div tabindex="-1" style={{ position: "relative;" ,  "z-index": "1050" ,  display : "block" , width:"100%", height: "80vh" }}>
                                <div style={{ "text-align": "center", top: "50%", position: "relative"  }}>
                                    <img style={{height:"100px", }} src={require("../../assets/img/icons/LoaderIDEA.gif").default}></img>
                                </div>
                                <div class="modal-backdrop fade show"></div>
                            </div>
                
                        </Modal>
                        <ConsultaDomiciliacion consulta={consultaDomiciliacion} cambioTab={cambiaTabDomi} notificadomi={notificadomi} mensaje={mensajenotifdomi} limpianoti={limpianotificaciondomi}></ConsultaDomiciliacion>
                      </Row>
                    </Container>
                  </TabPane>
                  <TabPane tabId="tabs10">
                    <Container fluid>
                      <Row style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                        <Domiciliacion canceladomi={cancelaUsuCM} flujo={flujodomiciliacion} dataini={objinidomi}></Domiciliacion>
                      </Row>
                    </Container>
                  </TabPane>
                </TabContent>
              </Container>  
              <Compotp esperando={cargandootpcreausu} pideotp={otpcreacionusu} funcrespadre={respuestaotpcreacionusu} mensaje={"Digita la clave temporal que se te envio para la creacion de un nuevo usuario"}></Compotp>
              <Compotp esperando={cargandootpelimusu} pideotp={otpelimusu} funcrespadre={respuestaotpelimusu} mensaje={"Digita la clave temporal que se te envio para la eliminacion del usuario"}></Compotp>
              <Confirmmodal esperando={false} pideconfirm={confirmbloqueo} funcrespadre={confirmaBloqueoUsu} mensaje={mensconfirmbloqueoUsu}></Confirmmodal>
              <Confirmmodal esperando={false} pideconfirm={confirmdesbloc} funcrespadre={confirmaDesblocUsu} mensaje={mensconfirmdesblocUsu}></Confirmmodal>
              
              
              {/*mensaje exito*/}
              <Modal
                className="modal-dialog-centered"
                contentClassName=""
                isOpen={resultModal}
                //toggle={() => setResultModal(!cancelationModal)}
              >
                <div className="p-4">
                  <div class="my-modal-header">
                    <img
                      alt="delete-icon"
                      class="my-header-brand-img"
                      src={exitoCreacion}
                      
                    />
                    <div class="header-title">
                      <h5 class="avv-title-bold">Proceso exitoso</h5>
                      <p class="header-subtitle">
                          El usuario fue creado con éxito.
                      </p>
                    </div>
                  </div>
                  <div class="my-modal-footer pt-2">
                    <button
                      class="btn bg-green text-white"
                      type="button"
                      onClick={() => {                    
                        setResultModal(false);
                        setStepLine(0);
                        setmaxstepcreaUsu(0);
                        setTabs(4);
                        
                      }}
                    >
                      Continuar
                    </button>
                  </div>
                </div>
              </Modal>
    {/*fin mensaje */}
    
            </>
          );
          break;
        case 2:
            return (
              <div className="header pb-4 pt-5 pt-md-8">
                <div className="mb-xl-0 shadow " style={{display:"flex",flexDirection:"row",justifyContent:"space-around",alignItems:"center",borderRadius:"10px",background:"#FFFFFF", margin:"10px 10px 10px 10px"}}>
                  <h1>No tiene permisos para esta sección</h1>
                </div>
              </div>
            )
          break;
        case 3:
          return (
            <Campoformato esSupervisor = {newUser.IsSupervisorUser} terminar={saliryguardapopOpcProd} salir={salirpopOpcProd} data={permisosProd} replica={1}></Campoformato> 
          );

        break;
        default:
          return (
            <div>

            </div>
          )
          break;
      }
    }
  }
  return <NavsTransfer></NavsTransfer>;
}

export default Security;
